// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Leaderboard Page Styles */

.leaderboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
  flex-wrap: wrap;
  gap: 16px;
}

/* Leaderboard Filters */
.leaderboard-filters {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 24px;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  border-radius: 24px;
  padding: 20px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.filter-group {
  display: flex;
  gap: 12px;
  align-items: center;
}

/* Results Count */
.results-count {
  margin-bottom: 20px;
  padding: 8px 16px;
  background: rgba(139, 92, 246, 0.1);
  border-radius: 20px;
  display: inline-block;
  font-size: 13px;
  color: #a78bfa;
}

/* Leaderboard Table */
.leaderboard-table-container {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  overflow-x: auto;
  margin-bottom: 24px;
}

.leaderboard-table {
  width: 100%;
  border-collapse: collapse;
}

.leaderboard-table th {
  text-align: left;
  padding: 16px 20px;
  color: rgba(255, 255, 255, 0.7);
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 1px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.leaderboard-table td {
  padding: 16px 20px;
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.leaderboard-row {
  transition: all 0.3s ease;
}

.leaderboard-row:hover {
  background: rgba(255, 255, 255, 0.05);
  transform: translateX(4px);
}

.leaderboard-row.rank-1 {
  background: linear-gradient(90deg, rgba(255, 215, 0, 0.1), transparent);
}

.leaderboard-row.rank-2 {
  background: linear-gradient(90deg, rgba(192, 192, 192, 0.1), transparent);
}

.leaderboard-row.rank-3 {
  background: linear-gradient(90deg, rgba(205, 127, 50, 0.1), transparent);
}

/* Rank Cell */
.rank-cell {
  width: 80px;
}

.rank-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 40px;
  font-size: 14px;
  font-weight: 700;
  background: rgba(255, 255, 255, 0.1);
}

.rank-badge.rank-1 {
  background: linear-gradient(135deg, #ffd700, #ffb347);
  color: #000;
}

.rank-badge.rank-2 {
  background: linear-gradient(135deg, #c0c0c0, #a0a0a0);
  color: #000;
}

.rank-badge.rank-3 {
  background: linear-gradient(135deg, #cd7f32, #b87333);
  color: #fff;
}

/* Player Cell */
.player-cell {
  min-width: 180px;
}

.player-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.player-avatar {
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #8b5cf6, #ec489a);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 16px;
  color: white;
}

.player-name {
  font-weight: 600;
  color: white;
}

.crown-icon {
  font-size: 14px;
  margin-left: 4px;
}

/* Wins/Losses Cells */
.wins-cell, .losses-cell {
  width: 100px;
}

.wins-badge {
  display: inline-block;
  padding: 4px 12px;
  background: rgba(16, 185, 129, 0.2);
  color: #10b981;
  border-radius: 20px;
  font-weight: 600;
  font-size: 13px;
}

.losses-badge {
  display: inline-block;
  padding: 4px 12px;
  background: rgba(239, 68, 68, 0.2);
  color: #f87171;
  border-radius: 20px;
  font-weight: 600;
  font-size: 13px;
}

.games-cell {
  width: 100px;
  font-weight: 600;
  color: white;
}

/* Win Rate Cell */
.winrate-cell {
  min-width: 180px;
}

.winrate-container {
  position: relative;
  height: 32px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 16px;
  overflow: hidden;
  display: flex;
  align-items: center;
}

.winrate-bar {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  border-radius: 16px;
  transition: width 0.3s ease;
}

.winrate-value {
  position: relative;
  z-index: 1;
  padding: 0 12px;
  font-size: 12px;
  font-weight: 600;
  color: white;
  text-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
}

/* Leaderboard Grid */
.leaderboard-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  margin-bottom: 24px;
}

.leaderboard-card {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  border-radius: 24px;
  padding: 24px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
  position: relative;
  text-align: center;
}

.leaderboard-card:hover {
  transform: translateY(-4px);
  background: rgba(255, 255, 255, 0.08);
}

.leaderboard-card.rank-1 {
  border: 2px solid rgba(255, 215, 0, 0.5);
  background: linear-gradient(135deg, rgba(255, 215, 0, 0.1), transparent);
}

.leaderboard-card.rank-2 {
  border: 2px solid rgba(192, 192, 192, 0.5);
  background: linear-gradient(135deg, rgba(192, 192, 192, 0.1), transparent);
}

.leaderboard-card.rank-3 {
  border: 2px solid rgba(205, 127, 50, 0.5);
  background: linear-gradient(135deg, rgba(205, 127, 50, 0.1), transparent);
}

.card-rank {
  position: absolute;
  top: 16px;
  left: 16px;
}

.rank-badge-large {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 48px;
  font-size: 20px;
  font-weight: 700;
  background: rgba(255, 255, 255, 0.1);
}

.rank-badge-large.rank-1 {
  background: linear-gradient(135deg, #ffd700, #ffb347);
  color: #000;
}

.rank-badge-large.rank-2 {
  background: linear-gradient(135deg, #c0c0c0, #a0a0a0);
  color: #000;
}

.rank-badge-large.rank-3 {
  background: linear-gradient(135deg, #cd7f32, #b87333);
  color: #fff;
}

.crown-decoration {
  position: absolute;
  top: 16px;
  right: 16px;
  font-size: 24px;
  opacity: 0.5;
}

.card-avatar {
  margin: 40px 0 16px;
}

.avatar-large {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #8b5cf6, #ec489a);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  font-weight: 700;
  color: white;
  margin: 0 auto;
  box-shadow: 0 4px 20px rgba(139, 92, 246, 0.3);
}

.card-name {
  font-size: 18px;
  font-weight: 700;
  color: white;
  margin-bottom: 20px;
}

.card-stats {
  display: flex;
  justify-content: space-around;
  margin-bottom: 20px;
  padding: 12px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 16px;
}

.stat-group {
  text-align: center;
}

.stat-group .stat-label {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.5);
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 4px;
}

.stat-group .stat-value {
  font-size: 20px;
  font-weight: 700;
  color: white;
}

.stat-group .stat-value.wins {
  color: #10b981;
}

.stat-group .stat-value.losses {
  color: #f87171;
}

.stat-divider {
  width: 1px;
  background: rgba(255, 255, 255, 0.2);
}

.card-winrate {
  margin-top: 16px;
}

.winrate-label {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.5);
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 8px;
}

.winrate-bar-container {
  position: relative;
  height: 8px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 8px;
}

.winrate-percent {
  font-size: 14px;
  font-weight: 600;
  color: white;
  text-align: center;
}

/* Leaderboard Footer */
.leaderboard-footer {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 20px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  margin-top: 24px;
}

.footer-stats {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 16px;
}

.footer-stats span {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
  padding: 8px 16px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 20px;
}

/* Responsive */
@media (max-width: 1024px) {
  .leaderboard-table th,
  .leaderboard-table td {
    padding: 12px 16px;
  }
  
  .rank-cell {
    width: 60px;
  }
  
  .wins-cell, .losses-cell, .games-cell {
    width: 80px;
  }
}

@media (max-width: 768px) {
  .leaderboard-filters {
    flex-direction: column;
    align-items: stretch;
  }
  
  .filter-group {
    justify-content: space-between;
  }
  
  .view-toggle {
    margin-left: auto;
  }
  
  .leaderboard-table th,
  .leaderboard-table td {
    padding: 10px 12px;
    font-size: 12px;
  }
  
  .player-avatar {
    width: 28px;
    height: 28px;
    font-size: 12px;
  }
  
  .rank-badge {
    width: 32px;
    height: 32px;
    font-size: 12px;
  }
  
  .wins-badge, .losses-badge {
    padding: 2px 8px;
    font-size: 11px;
  }
  
  .winrate-value {
    font-size: 10px;
    padding: 0 8px;
  }
  
  .footer-stats {
    flex-direction: column;
    align-items: center;
  }
  
  .leaderboard-grid {
    grid-template-columns: 1fr;
  }
  
  /* Hide some columns on mobile */
  .games-col, .games-cell {
    display: none;
  }
}

@media (max-width: 640px) {
  .losses-col, .losses-cell {
    display: none;
  }
  
  .winrate-col, .winrate-cell {
    min-width: 140px;
  }
}

/* Chess Lobby Styles */

.chess-lobby-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
  flex-wrap: wrap;
  gap: 16px;
}

/* User Stats Card */
.user-stats-card {
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.2), rgba(236, 72, 153, 0.2));
  backdrop-filter: blur(10px);
  border-radius: 24px;
  padding: 20px 24px;
  margin-bottom: 32px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.stats-row {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 12px;
}

.stat-icon {
  font-size: 28px;
}

.stat-info {
  display: flex;
  flex-direction: column;
}

.stat-label {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.6);
  text-transform: uppercase;
  letter-spacing: 1px;
}

.stat-value {
  font-size: 18px;
  font-weight: 700;
  color: white;
}

.stat-divider {
  width: 1px;
  height: 40px;
  background: rgba(255, 255, 255, 0.2);
}

/* Quick Actions Card */
.quick-actions-card {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  border-radius: 24px;
  padding: 24px;
  margin-bottom: 32px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.quick-actions-row {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.quick-action {
  flex: 1 1;
  background: linear-gradient(135deg, #8b5cf6, #ec489a);
  border: none;
  border-radius: 40px;
  padding: 14px 24px;
  color: white;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.quick-action.searching {
  background: rgba(255, 255, 255, 0.1);
  cursor: wait;
}

.quick-action:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(139, 92, 246, 0.4);
}

.join-by-code {
  display: flex;
  gap: 12px;
  flex: 1 1;
}

.code-input {
  flex: 1 1;
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 40px;
  padding: 12px 20px;
  color: white;
  font-size: 14px;
}

.code-input:focus {
  outline: none;
  border-color: #8b5cf6;
}

.join-btn {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 40px;
  padding: 12px 24px;
  color: white;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.join-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.2);
}

.join-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.match-found {
  margin-top: 16px;
  padding: 10px 16px;
  background: rgba(16, 185, 129, 0.2);
  border-radius: 12px;
  color: #10b981;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Create Challenges */
.create-challenges {
  margin-bottom: 40px;
}

.create-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
}

.create-card {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.create-card:hover {
  transform: translateY(-2px);
  background: rgba(255, 255, 255, 0.08);
}

.create-card.bot:hover {
  border-color: #8b5cf6;
}

.create-card.friendly:hover {
  border-color: #10b981;
}

.create-card.real:hover {
  border-color: #fbbf24;
}

.create-icon {
  font-size: 40px;
}

.create-info {
  flex: 1 1;
}

.create-title {
  font-size: 16px;
  font-weight: 600;
  color: white;
}

.create-desc {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  margin-top: 4px;
}

.create-arrow {
  font-size: 20px;
  color: rgba(255, 255, 255, 0.5);
  transition: transform 0.3s ease;
}

.create-card:hover .create-arrow {
  transform: translateX(4px);
}

/* Matches Section */
.matches-section {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  border-radius: 24px;
  padding: 24px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.matches-tabs {
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding-bottom: 16px;
}

.tab-btn {
  background: transparent;
  border: none;
  padding: 10px 20px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  border-radius: 40px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.tab-btn.active {
  background: linear-gradient(135deg, #8b5cf6, #ec489a);
  color: white;
}

.tab-count {
  background: rgba(0, 0, 0, 0.3);
  padding: 2px 8px;
  border-radius: 20px;
  font-size: 11px;
}

.tab-btn.active .tab-count {
  background: rgba(0, 0, 0, 0.5);
}

/* Matches List */
.matches-group {
  margin-bottom: 24px;
}

.group-title {
  font-size: 14px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 12px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.matches-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.match-card {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 20px;
  padding: 20px;
  transition: all 0.3s ease;
}

.match-card:hover {
  transform: translateX(4px);
  background: rgba(0, 0, 0, 0.4);
}

.match-card.available {
  border-left: 3px solid #10b981;
}

.match-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
}

.match-id {
  font-family: monospace;
  font-size: 12px;
  color: #a78bfa;
  background: rgba(139, 92, 246, 0.2);
  padding: 4px 12px;
  border-radius: 20px;
}

.match-badges {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.mode-badge {
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
}

.mode-badge.friendly {
  background: rgba(16, 185, 129, 0.2);
  color: #10b981;
}

.mode-badge.real {
  background: rgba(251, 191, 36, 0.2);
  color: #fbbf24;
}

.wager-badge {
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  background: rgba(239, 68, 68, 0.2);
  color: #f87171;
}

.status-badge {
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
}

.status-badge.pending {
  background: rgba(251, 191, 36, 0.2);
  color: #fbbf24;
}

.status-badge.ongoing {
  background: rgba(16, 185, 129, 0.2);
  color: #10b981;
}

.status-badge.completed {
  background: rgba(107, 114, 128, 0.2);
  color: #9ca3af;
}

/* Match Players */
.match-players {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.player {
  flex: 1 1;
  text-align: center;
}

.player-role {
  display: block;
  font-size: 10px;
  color: rgba(255, 255, 255, 0.5);
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 4px;
}

.player-name {
  font-size: 16px;
  font-weight: 600;
  color: white;
}

.player-name.waiting {
  color: rgba(255, 255, 255, 0.5);
  font-style: italic;
}

.vs-divider {
  font-size: 12px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.5);
  padding: 0 8px;
}

.match-details {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 16px;
  padding: 12px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 12px;
}

.detail-item {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
}

.match-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.action-btn {
  padding: 8px 20px;
  border-radius: 40px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
}

.action-btn.cancel {
  background: rgba(239, 68, 68, 0.2);
  color: #f87171;
}

.action-btn.cancel:hover {
  background: rgba(239, 68, 68, 0.3);
}

.action-btn.play, .action-btn.join {
  background: linear-gradient(135deg, #8b5cf6, #ec489a);
  color: white;
}

.action-btn.watch {
  background: rgba(255, 255, 255, 0.1);
  color: white;
}

.action-btn.play:hover, .action-btn.join:hover, .action-btn.watch:hover {
  transform: translateY(-2px);
}

/* Search Bar */
.search-bar {
  position: relative;
  margin-bottom: 20px;
}

.search-bar .search-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 16px;
  color: rgba(255, 255, 255, 0.5);
}

.search-bar .search-input {
  width: 100%;
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 40px;
  padding: 12px 16px 12px 40px;
  color: white;
  font-size: 14px;
}

.search-bar .search-input:focus {
  outline: none;
  border-color: #8b5cf6;
}

.clear-search {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.5);
  font-size: 18px;
  cursor: pointer;
}

/* Time Options */
.time-options {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.time-option {
  flex: 1 1;
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  padding: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.time-option.selected {
  border-color: #8b5cf6;
  background: rgba(139, 92, 246, 0.2);
}

.time-icon {
  font-size: 20px;
}

.time-label {
  font-size: 12px;
  font-weight: 600;
  color: white;
}

/* Wager Input */
.wager-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.wager-currency {
  position: absolute;
  left: 14px;
  font-size: 16px;
}

.wager-input {
  padding-left: 40px !important;
  padding-right: 60px !important;
  background: rgba(15, 23, 42, 0.9) !important;
  background-color: rgba(15, 23, 42, 0.9) !important;
  border: 1px solid rgba(148, 163, 184, 0.45) !important;
  color: #f8fafc !important;
  -webkit-text-fill-color: #f8fafc !important;
  caret-color: #f8fafc !important;
  box-shadow: none !important;
  opacity: 1 !important;
  font-weight: 700;
  appearance: textfield;
  -moz-appearance: textfield;
  color-scheme: dark;
}

.wager-input::placeholder {
  color: rgba(203, 213, 225, 0.85);
}

.wager-input:-webkit-autofill,
.wager-input:-webkit-autofill:hover,
.wager-input:-webkit-autofill:focus {
  -webkit-text-fill-color: #f8fafc !important;
  box-shadow: 0 0 0 1000px rgba(15, 23, 42, 0.9) inset !important;
  background-color: rgba(15, 23, 42, 0.9) !important;
}

.wager-suffix {
  position: absolute;
  right: 14px;
  color: rgba(255, 255, 255, 0.5);
  font-size: 13px;
}

/* Error Hint */
.error-hint {
  margin-top: 8px;
  font-size: 12px;
  color: #f87171;
}

/* Chess Modal */
.chess-modal {
  max-width: 500px;
}

/* Spinner Small */
.spinner-small {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
  display: inline-block;
}

/* Responsive */
@media (max-width: 768px) {
  .stats-row {
    flex-direction: column;
    gap: 16px;
  }
  
  .stat-divider {
    display: none;
  }
  
  .quick-actions-row {
    flex-direction: column;
  }
  
  .join-by-code {
    flex-direction: column;
  }
  
  .match-players {
    flex-direction: column;
    text-align: center;
  }
  
  .vs-divider {
    display: none;
  }
  
  .match-actions {
    justify-content: center;
  }
  
  .time-options {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .create-cards {
    grid-template-columns: 1fr;
  }

  .tab-btn .tab-text {
    display: none;
  }
}


/* Transactions Page Styles */

.transactions-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
  flex-wrap: wrap;
  gap: 16px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-icon {
  font-size: 48px;
  background: linear-gradient(135deg, #8b5cf6, #ec489a);
  width: 64px;
  height: 64px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
}

.page-title {
  font-size: 32px;
  font-weight: 800;
  color: white;
  margin: 0;
}

.page-subtitle {
  color: rgba(255, 255, 255, 0.6);
  margin: 4px 0 0;
}

.back-btn {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 40px;
  padding: 10px 20px;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
}

.back-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}

/* Balance Card */
.balance-card {
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.2), rgba(236, 72, 153, 0.2));
  backdrop-filter: blur(10px);
  border-radius: 32px;
  padding: 32px;
  margin-bottom: 32px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.balance-label {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  text-transform: uppercase;
  letter-spacing: 1px;
}

.balance-value {
  font-size: 48px;
  font-weight: 800;
  color: white;
  margin-top: 8px;
}

.balance-actions {
  display: flex;
  gap: 12px;
}

.balance-action {
  padding: 12px 24px;
  border-radius: 40px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
}

.balance-action.deposit {
  background: linear-gradient(135deg, #10b981, #059669);
  color: white;
}

.balance-action.deposit.active {
  background: linear-gradient(135deg, #059669, #047857);
  box-shadow: 0 4px 15px rgba(16, 185, 129, 0.3);
}

.balance-action.withdraw {
  background: rgba(255, 255, 255, 0.1);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.balance-action.withdraw.active {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.3);
}

/* Transaction Cards */
.transaction-card {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  border-radius: 32px;
  padding: 32px;
  margin-bottom: 32px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.card-header {
  margin-bottom: 24px;
}

.card-title {
  font-size: 24px;
  font-weight: 700;
  color: white;
  margin: 0;
}

.card-subtitle {
  color: rgba(255, 255, 255, 0.6);
  margin: 4px 0 0;
}

/* Provider Selector */
.provider-selector {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
  margin-bottom: 32px;
}

.provider-option {
  background: rgba(0, 0, 0, 0.3);
  border: 2px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.provider-option.selected {
  border-color: #8b5cf6;
  background: rgba(139, 92, 246, 0.1);
}

.provider-icon {
  font-size: 32px;
}

.provider-info {
  flex: 1 1;
}

.provider-name {
  font-size: 16px;
  font-weight: 600;
  color: white;
}

.provider-desc {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  margin-top: 4px;
}

.provider-check {
  width: 24px;
  height: 24px;
  background: #8b5cf6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 14px;
}

/* Forms */
.deposit-form, .withdraw-form {
  max-width: 500px;
}

.form-group {
  margin-bottom: 24px;
}

.form-label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: white;
  margin-bottom: 8px;
}

.form-input, .form-select {
  width: 100%;
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  padding: 14px 16px;
  color: white;
  font-size: 16px;
  transition: all 0.3s ease;
}

.form-input:focus, .form-select:focus {
  outline: none;
  border-color: #8b5cf6;
}

.form-hint {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  margin-top: 6px;
}

.amount-input-wrapper {
  position: relative;
}

.amount-input {
  width: 100%;
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  padding: 14px 16px;
  color: white;
  font-size: 24px;
  font-weight: 600;
  text-align: center;
}

.amount-suggestions {
  display: flex;
  gap: 8px;
  margin-top: 12px;
  justify-content: center;
}

.suggestion {
  background: rgba(255, 255, 255, 0.1);
  border: none;
  border-radius: 20px;
  padding: 6px 12px;
  color: white;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.suggestion:hover {
  background: rgba(255, 255, 255, 0.2);
}

/* Network Selector */
.network-selector {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;
}

.network-option {
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: left;
}

.network-option.selected {
  border-color: #8b5cf6;
  background: rgba(139, 92, 246, 0.1);
}

.network-icon {
  font-size: 20px;
  display: block;
  margin-bottom: 8px;
}

.network-name {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: white;
  margin-bottom: 4px;
}

.network-fee {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.5);
}

/* Buttons */
.deposit-btn, .withdraw-btn {
  width: 100%;
  background: linear-gradient(135deg, #8b5cf6, #ec489a);
  border: none;
  border-radius: 40px;
  padding: 14px;
  color: white;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 8px;
}

.deposit-btn:hover:not(:disabled), .withdraw-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(139, 92, 246, 0.4);
}

.deposit-btn:disabled, .withdraw-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.recheck-btn {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 40px;
  padding: 10px 20px;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 16px;
  width: 100%;
}

.recheck-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}

/* Messages */
.message {
  padding: 12px 16px;
  border-radius: 12px;
  margin-top: 16px;
  font-size: 14px;
}

.message.success {
  background: rgba(16, 185, 129, 0.2);
  border: 1px solid rgba(16, 185, 129, 0.5);
  color: #10b981;
}

.message.error {
  background: rgba(239, 68, 68, 0.2);
  border: 1px solid rgba(239, 68, 68, 0.5);
  color: #f87171;
}

.message.info {
  background: rgba(139, 92, 246, 0.2);
  border: 1px solid rgba(139, 92, 246, 0.5);
  color: #a78bfa;
}

/* Admin Section */
.admin-section {
  margin-bottom: 32px;
}

.admin-card {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  border-radius: 32px;
  padding: 32px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.mode-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 32px;
  padding-bottom: 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.mode-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.mode-label {
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
}

.mode-value {
  font-size: 14px;
  font-weight: 600;
  padding: 6px 12px;
  border-radius: 20px;
}

.mode-value.admin_approve {
  background: rgba(239, 68, 68, 0.2);
  color: #f87171;
}

.mode-value.auto {
  background: rgba(16, 185, 129, 0.2);
  color: #10b981;
}

.mode-actions {
  display: flex;
  gap: 12px;
}

.mode-btn {
  padding: 8px 20px;
  border-radius: 40px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  background: rgba(255, 255, 255, 0.1);
  color: white;
}

.mode-btn.active {
  background: linear-gradient(135deg, #8b5cf6, #ec489a);
}

.mode-btn:hover:not(:disabled) {
  transform: translateY(-2px);
}

/* Pending Withdrawals */
.pending-title {
  font-size: 18px;
  font-weight: 600;
  color: white;
  margin-bottom: 16px;
}

.pending-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.pending-item {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 16px;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}

.pending-info {
  flex: 1 1;
}

.pending-user {
  font-weight: 600;
  color: white;
  margin-bottom: 4px;
}

.pending-amount {
  font-size: 14px;
  color: #fbbf24;
  margin-bottom: 4px;
}

.pending-address {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  font-family: monospace;
}

.pending-actions {
  display: flex;
  gap: 12px;
}

.approve-btn, .reject-btn {
  padding: 8px 20px;
  border-radius: 40px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
}

.approve-btn {
  background: linear-gradient(135deg, #10b981, #059669);
  color: white;
}

.reject-btn {
  background: rgba(239, 68, 68, 0.2);
  color: #f87171;
  border: 1px solid rgba(239, 68, 68, 0.5);
}

.approve-btn:hover:not(:disabled), .reject-btn:hover:not(:disabled) {
  transform: translateY(-2px);
}

/* Filters Section */
.filters-section {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  border-radius: 32px;
  padding: 32px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.filters-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 24px;
}

.filters-title {
  font-size: 20px;
  font-weight: 700;
  color: white;
  margin: 0;
}

.filters-controls {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.filter-select {
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 40px;
  padding: 8px 16px;
  color: white;
  font-size: 14px;
  cursor: pointer;
}

/* Transactions List */
.transactions-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.transaction-item {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 16px;
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 16px;
  transition: all 0.3s ease;
}

.transaction-item:hover {
  background: rgba(0, 0, 0, 0.4);
  transform: translateX(4px);
}

.transaction-icon {
  width: 48px;
  height: 48px;
  background: rgba(139, 92, 246, 0.2);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
}

.transaction-icon:empty::before {
  content: '↩️';
}

.transaction-info {
  flex: 1 1;
}

.transaction-category {
  font-size: 14px;
  font-weight: 600;
  color: white;
  text-transform: capitalize;
}

.transaction-game {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  font-weight: normal;
}

.transaction-desc {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  margin-top: 4px;
}

.transaction-date {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.4);
  margin-top: 4px;
}

.transaction-amount {
  font-size: 18px;
  font-weight: 700;
  min-width: 80px;
  text-align: right;
}

.transaction-balance {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  min-width: 80px;
  text-align: right;
}

/* Deposit History */
.deposit-history {
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

/* Withdrawal History */
.withdrawal-history {
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.history-title {
  font-size: 18px;
  font-weight: 600;
  color: white;
  margin-bottom: 16px;
}

.history-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 300px;
  overflow-y: auto;
}

.history-item {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 12px;
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.history-amount {
  font-size: 16px;
  font-weight: 600;
  color: white;
}

.history-date {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.4);
  margin-top: 4px;
}

.history-details {
  display: flex;
  gap: 12px;
  align-items: center;
}

.history-status {
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
}

.history-status.status-pending {
  background: rgba(251, 191, 36, 0.2);
  color: #fbbf24;
}

.history-status.status-completed, .history-status.status-success {
  background: rgba(16, 185, 129, 0.2);
  color: #10b981;
}

.history-status.status-failed, .history-status.status-rejected {
  background: rgba(239, 68, 68, 0.2);
  color: #f87171;
}

.history-network {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.5);
  font-family: monospace;
}

/* Loading & Empty States */
.loading-state, .error-state, .empty-state {
  text-align: center;
  padding: 48px;
}

.spinner {
  width: 24px;
  height: 24px;
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-top-color: #8b5cf6;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  display: inline-block;
  margin-right: 8px;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.empty-icon {
  font-size: 48px;
  margin-bottom: 16px;
  opacity: 0.5;
}

.empty-text {
  color: rgba(255, 255, 255, 0.5);
}

.error-icon {
  font-size: 24px;
  margin-right: 8px;
}

/* Responsive */
@media (max-width: 768px) {
  .balance-value {
    font-size: 32px;
  }
  
  .transaction-item {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .transaction-amount, .transaction-balance {
    text-align: left;
    width: 100%;
  }
  
  .pending-item {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .pending-actions {
    width: 100%;
  }
  
  .approve-btn, .reject-btn {
    flex: 1 1;
    text-align: center;
  }
  
  .mode-controls {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .filters-controls {
    width: 100%;
  }
  
  .filter-select {
    flex: 1 1;
  }
  
  .network-selector {
    grid-template-columns: 1fr;
  }
}

/* History Page Styles */

.history-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
  flex-wrap: wrap;
  gap: 16px;
}

/* Stats Overview */
.stats-overview {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 32px;
}

.stats-overview .stat-card {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  min-width: 120px;
}

.stats-overview .stat-card.total {
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.2), rgba(236, 72, 153, 0.2));
  border-left: 4px solid #8b5cf6;
}

.stats-overview .stat-card .stat-value {
  font-size: 28px;
  font-weight: 800;
  color: white;
}

.stats-overview .stat-card .stat-label {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  text-transform: uppercase;
  letter-spacing: 1px;
}

.stats-overview .stat-card .stat-icon {
  font-size: 32px;
}

.stats-overview .stat-card .stat-info {
  display: flex;
  flex-direction: column;
}

/* Filters Card */
.filters-card {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  border-radius: 24px;
  padding: 24px;
  margin-bottom: 32px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.filters-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 16px;
}

.filters-row:last-child {
  margin-bottom: 0;
}

/* Search Wrapper */
.search-wrapper {
  position: relative;
  flex: 1 1;
  min-width: 250px;
}

.search-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 16px;
  color: rgba(255, 255, 255, 0.5);
}

.search-wrapper .search-input {
  width: 100%;
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 40px;
  padding: 12px 16px 12px 40px;
  color: white;
  font-size: 14px;
  transition: all 0.3s ease;
}

.search-wrapper .search-input:focus {
  outline: none;
  border-color: #8b5cf6;
}

.clear-search {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.5);
  font-size: 18px;
  cursor: pointer;
  padding: 0;
}

.clear-search:hover {
  color: white;
}

/* View Toggle */
.view-toggle {
  display: flex;
  gap: 8px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 40px;
  padding: 4px;
}

.view-btn {
  background: transparent;
  border: none;
  padding: 8px 16px;
  border-radius: 40px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.view-btn.active {
  background: linear-gradient(135deg, #8b5cf6, #ec489a);
  color: white;
}

.view-btn:hover:not(.active) {
  background: rgba(255, 255, 255, 0.1);
  color: white;
}

/* Category Filters */
.category-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  flex: 1 1;
}

.category-filter {
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 40px;
  padding: 8px 16px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.category-filter:hover {
  background: rgba(255, 255, 255, 0.1);
  color: white;
}

.category-filter.active {
  background: var(--category-color, #8b5cf6);
  border-color: var(--category-color, #8b5cf6);
  color: white;
}

.filter-icon {
  font-size: 14px;
}

.filter-count {
  background: rgba(0, 0, 0, 0.5);
  border-radius: 20px;
  padding: 2px 6px;
  font-size: 10px;
  margin-left: 4px;
}

.category-filter.active .filter-count {
  background: rgba(0, 0, 0, 0.3);
}

/* Sort Select */
.sort-select {
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 40px;
  padding: 8px 16px;
  color: white;
  font-size: 13px;
  cursor: pointer;
}

/* Date Filters */
.date-filters {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.date-input-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.date-input-group label {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.6);
  text-transform: uppercase;
  letter-spacing: 1px;
}

.date-input {
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  padding: 8px 12px;
  color: white;
  font-size: 13px;
  cursor: pointer;
}

.date-input:focus {
  outline: none;
  border-color: #8b5cf6;
}

.date-hint {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
}

.filter-error {
  margin-top: 12px;
  padding: 10px;
  background: rgba(239, 68, 68, 0.1);
  border-radius: 8px;
  color: #f87171;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* History List View */
.history-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
}

.history-item {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 20px;
  padding: 20px;
  display: flex;
  gap: 16px;
  transition: all 0.3s ease;
}

.history-item:hover {
  transform: translateX(4px);
  background: rgba(0, 0, 0, 0.4);
}

.history-item-icon {
  width: 56px;
  height: 56px;
  background: rgba(139, 92, 246, 0.2);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  border-left: 3px solid;
  flex-shrink: 0;
}

.history-item-content {
  flex: 1 1;
}

.history-item-header {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 8px;
}

.history-item-category {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.history-item-id {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.4);
  font-family: monospace;
}

.result-badge {
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
}

.result-badge.win {
  background: rgba(16, 185, 129, 0.2);
  color: #10b981;
}

.result-badge.loss {
  background: rgba(239, 68, 68, 0.2);
  color: #f87171;
}

.result-badge.draw {
  background: rgba(251, 191, 36, 0.2);
  color: #fbbf24;
}

.result-badge.completed {
  background: rgba(16, 185, 129, 0.2);
  color: #10b981;
}

.result-badge.pending {
  background: rgba(251, 191, 36, 0.2);
  color: #fbbf24;
}

.result-badge.played {
  background: rgba(139, 92, 246, 0.2);
  color: #a78bfa;
}

.history-item-title {
  font-size: 16px;
  font-weight: 600;
  color: white;
  margin-bottom: 4px;
}

.history-item-subtitle {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 4px;
}

.history-item-details {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  margin-bottom: 8px;
}

.history-item-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 8px;
}

.history-item-date {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.4);
  display: flex;
  align-items: center;
  gap: 4px;
}

.view-details-btn {
  background: rgba(139, 92, 246, 0.2);
  border: 1px solid rgba(139, 92, 246, 0.3);
  border-radius: 40px;
  padding: 6px 16px;
  color: #a78bfa;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.view-details-btn:hover {
  background: rgba(139, 92, 246, 0.3);
  transform: translateX(2px);
}

/* History Grid View */
.history-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 20px;
  margin-bottom: 24px;
}

.history-grid-item {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 20px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.history-grid-item:hover {
  transform: translateY(-4px);
  background: rgba(0, 0, 0, 0.4);
}

.grid-item-header {
  padding: 16px;
  border-top: 3px solid;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(0, 0, 0, 0.2);
}

.grid-item-category {
  display: flex;
  align-items: center;
  gap: 6px;
}

.grid-category-icon {
  font-size: 20px;
}

.grid-category-name {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.grid-item-content {
  padding: 16px;
}

.grid-item-title {
  font-size: 14px;
  font-weight: 600;
  color: white;
  margin-bottom: 8px;
}

.grid-item-subtitle {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 4px;
}

.grid-item-details {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.5);
}

.grid-item-footer {
  padding: 12px 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.grid-item-date {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.4);
}

.view-btn-small {
  background: rgba(139, 92, 246, 0.2);
  border: none;
  border-radius: 20px;
  padding: 4px 12px;
  color: #a78bfa;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.view-btn-small:hover {
  background: rgba(139, 92, 246, 0.3);
}

/* Results Summary */
.results-summary {
  text-align: center;
  padding: 16px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

/* Clear Filters Button */
.clear-filters-btn {
  margin-top: 20px;
  background: rgba(139, 92, 246, 0.2);
  border: 1px solid rgba(139, 92, 246, 0.3);
  border-radius: 40px;
  padding: 10px 24px;
  color: #a78bfa;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.clear-filters-btn:hover {
  background: rgba(139, 92, 246, 0.3);
}

/* Responsive */
@media (max-width: 768px) {
  .filters-row {
    flex-direction: column;
    align-items: stretch;
  }
  
  .category-filters {
    order: 1;
  }
  
  .sort-select {
    width: 100%;
  }
  
  .date-filters {
    width: 100%;
  }
  
  .date-input-group {
    flex: 1 1;
  }
  
  .date-input {
    width: 100%;
  }
  
  .history-item {
    flex-direction: column;
  }
  
  .history-item-icon {
    width: 48px;
    height: 48px;
    font-size: 24px;
  }
  
  .history-grid {
    grid-template-columns: 1fr;
  }
  
  .stats-overview {
    justify-content: center;
  }
  
  .stats-overview .stat-card {
    min-width: calc(33% - 12px);
  }
}

@media (max-width: 480px) {
  .stats-overview .stat-card {
    min-width: 100%;
  }
  
  .history-item-header {
    flex-wrap: wrap;
  }
  
  .history-item-footer {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .view-details-btn {
    width: 100%;
    text-align: center;
  }
}

/* Admin Dashboard Specific Styles */

/* Header Actions */
.header-actions {
  display: flex;
  gap: 12px;
  align-items: center;
}

.logout-btn {
  background: rgba(239, 68, 68, 0.2);
  border: 1px solid rgba(239, 68, 68, 0.3);
  border-radius: 40px;
  padding: 10px 20px;
  color: #f87171;
  cursor: pointer;
  transition: all 0.3s ease;
}

.logout-btn:hover {
  background: rgba(239, 68, 68, 0.3);
  transform: translateY(-2px);
}

/* Stats Grid */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin-bottom: 32px;
}

.stats-grid .stat-card {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
}

.stats-grid .stat-card:hover {
  transform: translateY(-2px);
  background: rgba(255, 255, 255, 0.08);
}

.stats-grid .stat-icon {
  font-size: 32px;
}

.stats-grid .stat-info {
  flex: 1 1;
}

.stats-grid .stat-label {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  text-transform: uppercase;
  letter-spacing: 1px;
}

.stats-grid .stat-value {
  font-size: 24px;
  font-weight: 700;
  color: white;
}

/* Admin Card */
.admin-card {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  border-radius: 32px;
  padding: 32px;
  margin-bottom: 32px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

/* Search Wrapper */
.search-wrapper {
  display: flex;
  gap: 12px;
  align-items: center;
  position: relative;
}

.search-wrapper .search-input {
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 40px;
  padding: 12px 16px 12px 40px;
  color: white;
  font-size: 14px;
  width: 300px;
}

.search-wrapper .search-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 16px;
  color: rgba(255, 255, 255, 0.5);
}

.search-btn {
  background: linear-gradient(135deg, #8b5cf6, #ec489a);
  border: none;
  border-radius: 40px;
  padding: 10px 20px;
  color: white;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.search-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.4);
}

/* Admin Table */
.table-responsive {
  overflow-x: auto;
  margin-top: 20px;
}

.admin-table {
  width: 100%;
  border-collapse: collapse;
}

.admin-table th {
  text-align: left;
  padding: 12px;
  color: rgba(255, 255, 255, 0.7);
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 1px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.admin-table td {
  padding: 12px;
  color: rgba(255, 255, 255, 0.9);
  font-size: 13px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.admin-table tr:hover {
  background: rgba(255, 255, 255, 0.03);
}

/* User Name Cell */
.user-name-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}

.online-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #4b5563;
  display: inline-block;
}

.online-dot.online {
  background: #10b981;
  box-shadow: 0 0 4px #10b981;
}

/* Role Badge */
.role-badge {
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
}

.role-badge.admin {
  background: linear-gradient(135deg, #8b5cf6, #ec489a);
  color: white;
}

.role-badge.user {
  background: rgba(59, 130, 246, 0.2);
  color: #60a5fa;
}

/* Status Badge */
.status-badge {
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
}

.status-badge.online {
  background: rgba(16, 185, 129, 0.2);
  color: #10b981;
}

.status-badge.offline {
  background: rgba(107, 114, 128, 0.2);
  color: #9ca3af;
}

.status-badge.blocked {
  background: rgba(239, 68, 68, 0.2);
  color: #f87171;
}

.status-badge.pending {
  background: rgba(251, 191, 36, 0.2);
  color: #fbbf24;
}

/* Category Badge */
.category-badge {
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  text-transform: capitalize;
}

.category-badge.deposit {
  background: rgba(16, 185, 129, 0.2);
  color: #10b981;
}

.category-badge.withdrawal {
  background: rgba(239, 68, 68, 0.2);
  color: #f87171;
}

.category-badge.wager {
  background: rgba(139, 92, 246, 0.2);
  color: #a78bfa;
}

.category-badge.payout {
  background: rgba(251, 191, 36, 0.2);
  color: #fbbf24;
}

/* Amount Cell */
.amount-cell.positive {
  color: #10b981;
  font-weight: 600;
}

.amount-cell.negative {
  color: #f87171;
  font-weight: 600;
}

.balance-cell {
  font-weight: 600;
  color: white;
}

.date-cell {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  white-space: nowrap;
}

/* Action Buttons */
.actions-cell {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.action-btn {
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
}

.action-btn.view {
  background: rgba(139, 92, 246, 0.2);
  color: #a78bfa;
}

.action-btn.view:hover {
  background: rgba(139, 92, 246, 0.3);
}

.action-btn.block {
  background: rgba(239, 68, 68, 0.2);
  color: #f87171;
}

.action-btn.block:hover {
  background: rgba(239, 68, 68, 0.3);
}

.action-btn.unblock {
  background: rgba(16, 185, 129, 0.2);
  color: #10b981;
}

.action-btn.unblock:hover {
  background: rgba(16, 185, 129, 0.3);
}

.action-btn.approve {
  background: rgba(16, 185, 129, 0.2);
  color: #10b981;
}

.action-btn.reject {
  background: rgba(239, 68, 68, 0.2);
  color: #f87171;
}

/* Pagination */
.pagination-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.pagination-btn {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 40px;
  padding: 8px 20px;
  color: white;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.pagination-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.2);
}

.pagination-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pagination-info {
  color: rgba(255, 255, 255, 0.6);
  font-size: 13px;
}

/* Export Button */
.export-btn {
  background: rgba(139, 92, 246, 0.2);
  border: 1px solid rgba(139, 92, 246, 0.3);
  border-radius: 40px;
  padding: 8px 20px;
  color: #a78bfa;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.export-btn:hover:not(:disabled) {
  background: rgba(139, 92, 246, 0.3);
}

/* Balance Form */
.balance-form {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  align-items: end;
}

.balance-form .form-group {
  margin-bottom: 0;
}

.balance-form .save-btn {
  margin-top: 0;
  padding: 12px 24px;
}

/* Settings Grid */
.settings-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  margin-bottom: 32px;
}

.setting-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.setting-item label {
  font-size: 12px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.7);
  text-transform: uppercase;
  letter-spacing: 1px;
}

.setting-item input {
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  padding: 10px 14px;
  color: white;
  font-size: 14px;
}

.setting-item input:focus {
  outline: none;
  border-color: #8b5cf6;
}

/* Distribution Section */
.distribution-section {
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.section-subtitle {
  font-size: 16px;
  font-weight: 600;
  color: white;
  margin-bottom: 20px;
}

.distribution-block {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 20px;
  padding: 16px;
  margin-bottom: 16px;
}

.distribution-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.distribution-header h4 {
  font-size: 14px;
  font-weight: 600;
  color: white;
  margin: 0;
}

.distribution-total {
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 20px;
}

.distribution-total.valid {
  background: rgba(16, 185, 129, 0.2);
  color: #10b981;
}

.distribution-total.invalid {
  background: rgba(239, 68, 68, 0.2);
  color: #f87171;
}

.distribution-inputs {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  gap: 12px;
}

.distribution-input {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.distribution-input label {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.6);
}

.distribution-input input {
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  padding: 8px 10px;
  color: white;
  font-size: 13px;
  text-align: center;
}

/* Mode Controls */
.mode-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.mode-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.mode-label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
}

.mode-value {
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
}

.mode-value.admin_approve {
  background: rgba(239, 68, 68, 0.2);
  color: #f87171;
}

.mode-value.auto {
  background: rgba(16, 185, 129, 0.2);
  color: #10b981;
}

.mode-actions {
  display: flex;
  gap: 12px;
}

.mode-btn {
  background: rgba(255, 255, 255, 0.1);
  border: none;
  border-radius: 40px;
  padding: 8px 20px;
  color: white;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.mode-btn.active {
  background: linear-gradient(135deg, #8b5cf6, #ec489a);
}

.mode-btn:hover:not(:disabled) {
  transform: translateY(-2px);
}

.refresh-btn-small {
  background: rgba(255, 255, 255, 0.1);
  border: none;
  border-radius: 40px;
  padding: 8px 16px;
  color: white;
  font-size: 12px;
  cursor: pointer;
}

/* Reconcile Controls */
.reconcile-controls {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}

.reconcile-option {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.reconcile-option label {
  font-size: 11px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.6);
  text-transform: uppercase;
  letter-spacing: 1px;
}

.reconcile-option select,
.reconcile-option input {
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  padding: 8px 12px;
  color: white;
  font-size: 13px;
}

/* Admin Actions */
.admin-actions {
  display: flex;
  gap: 16px;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 24px;
}

.dryrun-btn, .recover-btn {
  padding: 10px 24px;
  border-radius: 40px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
}

.dryrun-btn {
  background: rgba(255, 255, 255, 0.1);
  color: white;
}

.recover-btn {
  background: linear-gradient(135deg, #ef4444, #dc2626);
  color: white;
}

.dryrun-btn:hover:not(:disabled),
.recover-btn:hover:not(:disabled) {
  transform: translateY(-2px);
}

.error-hint {
  font-size: 12px;
  color: #f87171;
}

/* Reconcile Summary */
.reconcile-summary {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 16px;
  padding: 16px;
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 12px;
}

.summary-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.summary-label {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.5);
  text-transform: uppercase;
}

.summary-value {
  font-size: 16px;
  font-weight: 700;
  color: white;
}

/* Profile Modal */
.profile-modal {
  background: linear-gradient(135deg, #1e1b4b, #0f172a);
  border-radius: 32px;
  max-width: 600px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.profile-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  padding: 20px;
}

.profile-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.field-label {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.5);
  text-transform: uppercase;
  letter-spacing: 1px;
}

.field-value {
  font-size: 14px;
  font-weight: 600;
  color: white;
}

.field-value.balance {
  color: #fbbf24;
  font-size: 18px;
}

.transactions-title {
  font-size: 16px;
  font-weight: 600;
  color: white;
  padding: 0 20px;
  margin-bottom: 12px;
}

.transactions-list {
  padding: 0 20px 20px;
}

.transaction-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  margin-bottom: 8px;
  font-size: 12px;
  flex-wrap: wrap;
  gap: 8px;
}

.transaction-date {
  color: rgba(255, 255, 255, 0.5);
  font-size: 10px;
}

.transaction-category {
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 10px;
  font-weight: 600;
  text-transform: capitalize;
}

.transaction-category.deposit {
  background: rgba(16, 185, 129, 0.2);
  color: #10b981;
}

.transaction-category.withdrawal {
  background: rgba(239, 68, 68, 0.2);
  color: #f87171;
}

.transaction-amount {
  font-weight: 600;
}

.transaction-amount.positive {
  color: #10b981;
}

.transaction-amount.negative {
  color: #f87171;
}

.transaction-balance {
  color: rgba(255, 255, 255, 0.6);
}

/* Empty State Small */
.empty-state-small {
  text-align: center;
  padding: 20px;
  color: rgba(255, 255, 255, 0.5);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.empty-state-small .empty-icon {
  font-size: 32px;
  opacity: 0.5;
}

/* Address Cell */
.address-cell {
  font-family: monospace;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.6);
}

/* Empty Cell */
.empty-cell {
  text-align: center;
  padding: 40px;
  color: rgba(255, 255, 255, 0.5);
}

/* Responsive */
@media (max-width: 768px) {
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .balance-form {
    grid-template-columns: 1fr;
  }
  
  .mode-controls {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .distribution-inputs {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .profile-grid {
    grid-template-columns: 1fr;
  }
  
  .actions-cell {
    flex-direction: column;
  }
  
  .search-wrapper {
    width: 100%;
  }
  
  .search-wrapper .search-input {
    width: 100%;
  }
  
  .admin-card {
    padding: 20px;
  }
}

/* Checkers Lobby Specific Styles */

.checkers-icon {
  font-size: 36px;
  background: linear-gradient(135deg, #f59e0b, #ef4444);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Time Options with Descriptions */
.time-option {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 12px;
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 80px;
}

.time-option.selected {
  border-color: #f59e0b;
  background: rgba(245, 158, 11, 0.2);
}

.time-icon {
  font-size: 20px;
}

.time-label {
  font-size: 12px;
  font-weight: 600;
  color: white;
}

.time-desc {
  font-size: 9px;
  color: rgba(255, 255, 255, 0.5);
}

/* Quick Action Button */
.quick-action {
  flex: 1 1;
  background: linear-gradient(135deg, #f59e0b, #ef4444);
  border: none;
  border-radius: 40px;
  padding: 14px 24px;
  color: white;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.quick-action.searching {
  background: rgba(255, 255, 255, 0.1);
  cursor: wait;
}

.quick-action:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(245, 158, 11, 0.4);
}

/* Create Cards with Checkers Theme */
.create-card.bot {
  border-left: 3px solid #f59e0b;
}

.create-card.bot:hover {
  border-color: #f59e0b;
  box-shadow: 0 4px 20px rgba(245, 158, 11, 0.2);
}

.create-card.friendly {
  border-left: 3px solid #10b981;
}

.create-card.friendly:hover {
  border-color: #10b981;
  box-shadow: 0 4px 20px rgba(16, 185, 129, 0.2);
}

.create-card.real {
  border-left: 3px solid #ef4444;
}

.create-card.real:hover {
  border-color: #ef4444;
  box-shadow: 0 4px 20px rgba(239, 68, 68, 0.2);
}

.create-icon {
  font-size: 40px;
  width: 60px;
  text-align: center;
}

/* Spinner Small */
.spinner-small {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
  display: inline-block;
}

/* Quick Actions Row */
.quick-actions-row {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.join-by-code {
  display: flex;
  gap: 12px;
  flex: 1 1;
}

.code-input {
  flex: 1 1;
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 40px;
  padding: 12px 20px;
  color: white;
  font-size: 14px;
}

.code-input:focus {
  outline: none;
  border-color: #f59e0b;
}

.join-btn {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 40px;
  padding: 12px 24px;
  color: white;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.join-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.2);
}

.join-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.match-found {
  margin-top: 16px;
  padding: 10px 16px;
  background: rgba(16, 185, 129, 0.2);
  border-radius: 12px;
  color: #10b981;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Search Bar with Icon */
.search-bar {
  position: relative;
  margin-bottom: 20px;
}

.search-bar .search-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 16px;
  color: rgba(255, 255, 255, 0.5);
}

.search-bar .search-input {
  width: 100%;
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 40px;
  padding: 12px 16px 12px 40px;
  color: white;
  font-size: 14px;
}

.search-bar .search-input:focus {
  outline: none;
  border-color: #f59e0b;
}

.clear-search {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.5);
  font-size: 18px;
  cursor: pointer;
}

.clear-search:hover {
  color: white;
}

/* Clear Filters Button */
.clear-filters-btn {
  margin-top: 20px;
  background: rgba(245, 158, 11, 0.2);
  border: 1px solid rgba(245, 158, 11, 0.3);
  border-radius: 40px;
  padding: 10px 24px;
  color: #f59e0b;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.clear-filters-btn:hover {
  background: rgba(245, 158, 11, 0.3);
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .time-option {
    min-width: 70px;
    padding: 8px;
  }
  
  .time-desc {
    display: none;
  }
  
  .quick-actions-row {
    flex-direction: column;
  }
  
  .join-by-code {
    flex-direction: column;
  }
  
  .create-icon {
    font-size: 32px;
    width: 50px;
  }
}
/* Flappy Lobby Specific Styles */

.flappy-icon {
  font-size: 36px;
  background: linear-gradient(135deg, #10b981, #3b82f6);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: flap 0.5s ease-in-out infinite;
}

@keyframes flap {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-3px); }
}

/* Quick Action Buttons */
.quick-action.flappy-quick {
  background: linear-gradient(135deg, #10b981, #3b82f6);
  flex: 1 1;
}

.quick-action.flappy-quick:hover:not(:disabled) {
  box-shadow: 0 4px 15px rgba(16, 185, 129, 0.4);
}

.practice-btn {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 40px;
  padding: 14px 24px;
  color: white;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.practice-btn:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
}

/* Create Cards with Flappy Theme */
.create-card.practice {
  border-left: 3px solid #10b981;
}

.create-card.practice:hover {
  border-color: #10b981;
  box-shadow: 0 4px 20px rgba(16, 185, 129, 0.2);
}

.create-card.friendly {
  border-left: 3px solid #3b82f6;
}

.create-card.friendly:hover {
  border-color: #3b82f6;
  box-shadow: 0 4px 20px rgba(59, 130, 246, 0.2);
}

.create-card.real {
  border-left: 3px solid #ef4444;
}

.create-card.real:hover {
  border-color: #ef4444;
  box-shadow: 0 4px 20px rgba(239, 68, 68, 0.2);
}

/* Duration Options */
.time-option {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 12px;
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 70px;
}

.time-option.selected {
  border-color: #10b981;
  background: rgba(16, 185, 129, 0.2);
}

.time-icon {
  font-size: 20px;
}

.time-label {
  font-size: 12px;
  font-weight: 600;
  color: white;
}

.time-desc {
  font-size: 9px;
  color: rgba(255, 255, 255, 0.5);
}

/* Quick Actions Row */
.quick-actions-row {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

/* Search Bar */
.search-bar {
  position: relative;
  margin-bottom: 20px;
}

.search-bar .search-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 16px;
  color: rgba(255, 255, 255, 0.5);
}

.search-bar .search-input {
  width: 100%;
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 40px;
  padding: 12px 16px 12px 40px;
  color: white;
  font-size: 14px;
}

.search-bar .search-input:focus {
  outline: none;
  border-color: #10b981;
}

.clear-search {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.5);
  font-size: 18px;
  cursor: pointer;
}

.clear-search:hover {
  color: white;
}

/* Clear Filters Button */
.clear-filters-btn {
  margin-top: 20px;
  background: rgba(16, 185, 129, 0.2);
  border: 1px solid rgba(16, 185, 129, 0.3);
  border-radius: 40px;
  padding: 10px 24px;
  color: #10b981;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.clear-filters-btn:hover {
  background: rgba(16, 185, 129, 0.3);
}

/* Spinner Small */
.spinner-small {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
  display: inline-block;
}

/* Match Card Status Badge */
.status-badge {
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
}

.status-badge.pending {
  background: rgba(251, 191, 36, 0.2);
  color: #fbbf24;
}

.status-badge.ongoing {
  background: rgba(16, 185, 129, 0.2);
  color: #10b981;
}

.status-badge.completed {
  background: rgba(107, 114, 128, 0.2);
  color: #9ca3af;
}

/* Mode Badge */
.mode-badge {
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
}

.mode-badge.friendly {
  background: rgba(59, 130, 246, 0.2);
  color: #60a5fa;
}

.mode-badge.real {
  background: rgba(239, 68, 68, 0.2);
  color: #f87171;
}

/* Wager Badge */
.wager-badge {
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  background: rgba(251, 191, 36, 0.2);
  color: #fbbf24;
}

/* Match Card */
.match-card {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 20px;
  padding: 20px;
  transition: all 0.3s ease;
  margin-bottom: 16px;
}

.match-card:hover {
  transform: translateX(4px);
  background: rgba(0, 0, 0, 0.4);
}

.match-card.available {
  border-left: 3px solid #10b981;
}

.match-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
}

.match-id {
  font-family: monospace;
  font-size: 12px;
  color: #a78bfa;
  background: rgba(139, 92, 246, 0.2);
  padding: 4px 12px;
  border-radius: 20px;
}

.match-badges {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.match-players {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.player {
  flex: 1 1;
  text-align: center;
}

.player-role {
  display: block;
  font-size: 10px;
  color: rgba(255, 255, 255, 0.5);
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 4px;
}

.player-name {
  font-size: 16px;
  font-weight: 600;
  color: white;
}

.player-name.waiting {
  color: rgba(255, 255, 255, 0.5);
  font-style: italic;
}

.vs-divider {
  font-size: 12px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.5);
  padding: 0 8px;
}

.match-details {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 16px;
  padding: 12px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 12px;
}

.detail-item {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
}

.match-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  flex-wrap: wrap;
}

.action-btn {
  padding: 8px 20px;
  border-radius: 40px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
}

.action-btn.join {
  background: linear-gradient(135deg, #10b981, #3b82f6);
  color: white;
}

.action-btn.play {
  background: linear-gradient(135deg, #8b5cf6, #ec489a);
  color: white;
}

.action-btn.cancel {
  background: rgba(239, 68, 68, 0.2);
  color: #f87171;
}

.action-btn.cancel:hover {
  background: rgba(239, 68, 68, 0.3);
}

.action-btn.join:hover, .action-btn.play:hover {
  transform: translateY(-2px);
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .time-option {
    min-width: 60px;
    padding: 8px;
  }
  
  .time-desc {
    display: none;
  }
  
  .quick-actions-row {
    flex-direction: column;
  }
  
  .practice-btn {
    justify-content: center;
  }
  
  .match-players {
    flex-direction: column;
    text-align: center;
  }
  
  .vs-divider {
    display: none;
  }
  
  .match-actions {
    justify-content: center;
  }
  
  .match-details {
    flex-direction: column;
    gap: 8px;
  }
}

/* Game Guide Page Styles */

.guide-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
  flex-wrap: wrap;
  gap: 16px;
}

.guide-icon-main {
  font-size: 48px;
  background: linear-gradient(135deg, #8b5cf6, #ec489a);
  width: 64px;
  height: 64px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Navigation Chips */
.guide-nav {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 32px;
  padding: 16px;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  border-radius: 60px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.nav-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 18px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 40px;
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.nav-chip:hover {
  background: rgba(255, 255, 255, 0.15);
  transform: translateY(-2px);
  color: white;
}

.nav-chip-highlight {
  background: linear-gradient(135deg, #8b5cf6, #ec489a);
  color: white;
  border: none;
}

.nav-chip-highlight:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(139, 92, 246, 0.4);
}

.chip-icon {
  font-size: 16px;
}

/* Guide Cards */
.guide-card {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  border-radius: 28px;
  padding: 28px;
  margin-bottom: 24px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
}

.guide-card:hover {
  transform: translateY(-2px);
  background: rgba(255, 255, 255, 0.08);
}

.general-card {
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.15), rgba(236, 72, 153, 0.1));
  border: 1px solid rgba(139, 92, 246, 0.3);
}

.card-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.card-icon {
  width: 52px;
  height: 52px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
}

.card-title {
  font-size: 20px;
  font-weight: 700;
  color: white;
  margin: 0;
}

.card-subtitle {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
  margin: 4px 0 0;
}

/* Guide Content */
.guide-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.guide-block {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 20px;
  padding: 18px;
}

.guide-block.compact {
  padding: 12px 18px;
}

.block-title {
  font-size: 14px;
  font-weight: 600;
  color: #a78bfa;
  margin: 0 0 12px;
  text-transform: uppercase;
  letter-spacing: 1px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.block-text {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.6;
  margin: 0;
}

.guide-list {
  margin: 0;
  padding-left: 20px;
}

.guide-list li {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
  margin-bottom: 8px;
}

.guide-list li:last-child {
  margin-bottom: 0;
}

/* Tips Block */
.tips-block {
  background: linear-gradient(135deg, rgba(16, 185, 129, 0.1), rgba(16, 185, 129, 0.05));
  border-left: 3px solid #10b981;
}

.tips-list li {
  color: #10b981 !important;
}

/* Command Block (WHOT specific) */
.command-block {
  background: linear-gradient(135deg, rgba(245, 158, 11, 0.1), rgba(245, 158, 11, 0.05));
  border-left: 3px solid #f59e0b;
}

/* Formula Block */
.formula-block {
  background: rgba(0, 0, 0, 0.3);
}

.formula-grid {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.formula-code {
  display: block;
  background: rgba(0, 0, 0, 0.5);
  padding: 10px 14px;
  border-radius: 12px;
  font-family: 'Courier New', monospace;
  font-size: 13px;
  color: #fbbf24;
  border-left: 3px solid #fbbf24;
}

/* Guide Grid */
.guide-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(420px, 1fr));
  gap: 24px;
  margin-top: 8px;
}

/* Guide Footer */
.guide-footer {
  margin-top: 32px;
  padding: 20px;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  text-align: center;
}

.footer-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
}

.footer-icon {
  font-size: 18px;
}

/* Responsive */
@media (max-width: 900px) {
  .guide-grid {
    grid-template-columns: 1fr;
  }
  
  .guide-nav {
    border-radius: 20px;
    justify-content: center;
  }
  
  .nav-chip {
    padding: 6px 14px;
    font-size: 12px;
  }
}

@media (max-width: 640px) {
  .guide-card {
    padding: 20px;
  }
  
  .card-header {
    flex-direction: column;
    text-align: center;
  }
  
  .card-title {
    font-size: 18px;
  }
  
  .guide-block {
    padding: 14px;
  }
  
  .formula-code {
    font-size: 11px;
    overflow-x: auto;
  }
  
  .guide-nav {
    overflow-x: auto;
    justify-content: flex-start;
    border-radius: 16px;
  }
  
  .footer-content {
    flex-direction: column;
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Dashboard.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mCAAmC;EACnC,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,uEAAuE;AACzE;;AAEA;EACE,yEAAyE;AAC3E;;AAEA;EACE,wEAAwE;AAC1E;;AAEA,cAAc;AACd;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,qDAAqD;EACrD,WAAW;AACb;;AAEA;EACE,qDAAqD;EACrD,WAAW;AACb;;AAEA;EACE,qDAAqD;EACrD,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mCAAmC;EACnC,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kCAAkC;EAClC,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,uCAAuC;AACzC;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,wCAAwC;EACxC,wEAAwE;AAC1E;;AAEA;EACE,0CAA0C;EAC1C,0EAA0E;AAC5E;;AAEA;EACE,yCAAyC;EACzC,yEAAyE;AAC3E;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,qDAAqD;EACrD,WAAW;AACb;;AAEA;EACE,qDAAqD;EACrD,WAAW;AACb;;AAEA;EACE,qDAAqD;EACrD,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;;IAEE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA,gCAAgC;EAChC;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,uBAAuB;;AAEvB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA,oBAAoB;AACpB;EACE,qFAAqF;EACrF,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,oCAAoC;AACtC;;AAEA,uBAAuB;AACvB;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,qDAAqD;EACrD,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,SAAS;EACT,SAAO;AACT;;AAEA;EACE,SAAO;EACP,8BAA8B;EAC9B,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;EACnC,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,iDAAiD;EACjD,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,mCAAmC;EACnC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,+BAA+B;EAC/B,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,0CAA0C;EAC1C,mBAAmB;EACnB,4BAA4B;EAC5B,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,8BAA8B;EAC9B,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,4CAA4C;EAC5C,kDAAkD;EAClD,sDAAsD;EACtD,yBAAyB;EACzB,2CAA2C;EAC3C,+BAA+B;EAC/B,2BAA2B;EAC3B,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB;EACrB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;;EAGE,2CAA2C;EAE3C,+DAA+D;EAC/D,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,+BAA+B;EAC/B,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,uBAAuB;EACvB,kBAAkB;EAClB,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;AACF;;;AAGA,6BAA6B;;AAE7B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,qDAAqD;EACrD,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA,iBAAiB;AACjB;EACE,qFAAqF;EACrF,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,8CAA8C;AAChD;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA,sBAAsB;AACtB;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,qDAAqD;EACrD,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,oCAAoC;AACtC;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,0CAA0C;EAC1C,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;EACpC,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;IACP,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,wBAAwB;;AAExB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,qFAAqF;EACrF,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,0CAA0C;EAC1C,mBAAmB;EACnB,4BAA4B;EAC5B,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,QAAQ;EACR,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,8BAA8B;EAC9B,0CAA0C;EAC1C,mBAAmB;EACnB,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,4CAA4C;EAC5C,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,gBAAgB;AAChB;EACE,8BAA8B;EAC9B,0CAA0C;EAC1C,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,0CAA0C;EAC1C,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kCAAkC;EAClC,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,8CAA8C;EAC9C,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;EACnC,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;AACrC;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,+BAA+B;EAC/B,8CAA8C;AAChD;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,mCAAmC;EACnC,yCAAyC;EACzC,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;AACrC;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;AACF;;AAEA,oCAAoC;;AAEpC,mBAAmB;AACnB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA,eAAe;AACf;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,0CAA0C;EAC1C,mBAAmB;EACnB,4BAA4B;EAC5B,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,qCAAqC;AACvC;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,eAAe;AACf;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,mCAAmC;EACnC,yCAAyC;EACzC,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;AACrC;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,0CAA0C;EAC1C,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,8BAA8B;EAC9B,0CAA0C;EAC1C,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,qDAAqD;EACrD,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,sBAAsB;EACtB,eAAe;EACf,+BAA+B;AACjC;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,aAAa;EACb,+BAA+B;AACjC;;AAEA,eAAe;AACf;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,mCAAmC;;AAEnC;EACE,eAAe;EACf,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,8BAA8B;EAC9B,0CAA0C;EAC1C,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,+BAA+B;AACjC;;AAEA,wBAAwB;AACxB;EACE,SAAO;EACP,qDAAqD;EACrD,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,qCAAqC;AACrC;EACE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,uBAAuB;EACvB,kBAAkB;EAClB,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,SAAO;AACT;;AAEA;EACE,SAAO;EACP,8BAA8B;EAC9B,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;EACnC,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,0CAA0C;EAC1C,mBAAmB;EACnB,4BAA4B;EAC5B,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,mCAAmC;EACnC,yCAAyC;EACzC,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;AACrC;;AAEA,2BAA2B;AAC3B;EACE;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;AACF;AACA,iCAAiC;;AAEjC;EACE,eAAe;EACf,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;AACrC;;AAEA,yBAAyB;AACzB;EACE,qDAAqD;EACrD,SAAO;AACT;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA,mCAAmC;AACnC;EACE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,8BAA8B;EAC9B,0CAA0C;EAC1C,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,+BAA+B;AACjC;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,0CAA0C;EAC1C,mBAAmB;EACnB,4BAA4B;EAC5B,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,mCAAmC;EACnC,yCAAyC;EACzC,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;AACrC;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,uBAAuB;EACvB,kBAAkB;EAClB,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,4BAA4B;AAC5B;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,mCAAmC;EACnC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,+BAA+B;EAC/B,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;EACE;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;AACF;;AAEA,2BAA2B;;AAE3B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,qDAAqD;EACrD,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,qCAAqC;EACrC,mBAAmB;EACnB,+BAA+B;EAC/B,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,sFAAsF;EACtF,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,sFAAsF;EACtF,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC;EACE,sFAAsF;EACtF,8BAA8B;AAChC;;AAEA,kBAAkB;AAClB;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,eAAe;EACf,cAAc;EACd,8BAA8B;AAChC;;AAEA,eAAe;AACf;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,eAAe;AACjB;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF","sourcesContent":["/* Leaderboard Page Styles */\n\n.leaderboard-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 32px;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n/* Leaderboard Filters */\n.leaderboard-filters {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin-bottom: 24px;\n  background: rgba(255, 255, 255, 0.05);\n  backdrop-filter: blur(10px);\n  border-radius: 24px;\n  padding: 20px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.filter-group {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n/* Results Count */\n.results-count {\n  margin-bottom: 20px;\n  padding: 8px 16px;\n  background: rgba(139, 92, 246, 0.1);\n  border-radius: 20px;\n  display: inline-block;\n  font-size: 13px;\n  color: #a78bfa;\n}\n\n/* Leaderboard Table */\n.leaderboard-table-container {\n  background: rgba(255, 255, 255, 0.05);\n  backdrop-filter: blur(10px);\n  border-radius: 24px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  overflow-x: auto;\n  margin-bottom: 24px;\n}\n\n.leaderboard-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.leaderboard-table th {\n  text-align: left;\n  padding: 16px 20px;\n  color: rgba(255, 255, 255, 0.7);\n  font-weight: 600;\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.leaderboard-table td {\n  padding: 16px 20px;\n  color: rgba(255, 255, 255, 0.9);\n  font-size: 14px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.leaderboard-row {\n  transition: all 0.3s ease;\n}\n\n.leaderboard-row:hover {\n  background: rgba(255, 255, 255, 0.05);\n  transform: translateX(4px);\n}\n\n.leaderboard-row.rank-1 {\n  background: linear-gradient(90deg, rgba(255, 215, 0, 0.1), transparent);\n}\n\n.leaderboard-row.rank-2 {\n  background: linear-gradient(90deg, rgba(192, 192, 192, 0.1), transparent);\n}\n\n.leaderboard-row.rank-3 {\n  background: linear-gradient(90deg, rgba(205, 127, 50, 0.1), transparent);\n}\n\n/* Rank Cell */\n.rank-cell {\n  width: 80px;\n}\n\n.rank-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 40px;\n  font-size: 14px;\n  font-weight: 700;\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.rank-badge.rank-1 {\n  background: linear-gradient(135deg, #ffd700, #ffb347);\n  color: #000;\n}\n\n.rank-badge.rank-2 {\n  background: linear-gradient(135deg, #c0c0c0, #a0a0a0);\n  color: #000;\n}\n\n.rank-badge.rank-3 {\n  background: linear-gradient(135deg, #cd7f32, #b87333);\n  color: #fff;\n}\n\n/* Player Cell */\n.player-cell {\n  min-width: 180px;\n}\n\n.player-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.player-avatar {\n  width: 36px;\n  height: 36px;\n  background: linear-gradient(135deg, #8b5cf6, #ec489a);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 16px;\n  color: white;\n}\n\n.player-name {\n  font-weight: 600;\n  color: white;\n}\n\n.crown-icon {\n  font-size: 14px;\n  margin-left: 4px;\n}\n\n/* Wins/Losses Cells */\n.wins-cell, .losses-cell {\n  width: 100px;\n}\n\n.wins-badge {\n  display: inline-block;\n  padding: 4px 12px;\n  background: rgba(16, 185, 129, 0.2);\n  color: #10b981;\n  border-radius: 20px;\n  font-weight: 600;\n  font-size: 13px;\n}\n\n.losses-badge {\n  display: inline-block;\n  padding: 4px 12px;\n  background: rgba(239, 68, 68, 0.2);\n  color: #f87171;\n  border-radius: 20px;\n  font-weight: 600;\n  font-size: 13px;\n}\n\n.games-cell {\n  width: 100px;\n  font-weight: 600;\n  color: white;\n}\n\n/* Win Rate Cell */\n.winrate-cell {\n  min-width: 180px;\n}\n\n.winrate-container {\n  position: relative;\n  height: 32px;\n  background: rgba(0, 0, 0, 0.3);\n  border-radius: 16px;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n}\n\n.winrate-bar {\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n  border-radius: 16px;\n  transition: width 0.3s ease;\n}\n\n.winrate-value {\n  position: relative;\n  z-index: 1;\n  padding: 0 12px;\n  font-size: 12px;\n  font-weight: 600;\n  color: white;\n  text-shadow: 0 0 2px rgba(0, 0, 0, 0.5);\n}\n\n/* Leaderboard Grid */\n.leaderboard-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 20px;\n  margin-bottom: 24px;\n}\n\n.leaderboard-card {\n  background: rgba(255, 255, 255, 0.05);\n  backdrop-filter: blur(10px);\n  border-radius: 24px;\n  padding: 24px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  transition: all 0.3s ease;\n  position: relative;\n  text-align: center;\n}\n\n.leaderboard-card:hover {\n  transform: translateY(-4px);\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.leaderboard-card.rank-1 {\n  border: 2px solid rgba(255, 215, 0, 0.5);\n  background: linear-gradient(135deg, rgba(255, 215, 0, 0.1), transparent);\n}\n\n.leaderboard-card.rank-2 {\n  border: 2px solid rgba(192, 192, 192, 0.5);\n  background: linear-gradient(135deg, rgba(192, 192, 192, 0.1), transparent);\n}\n\n.leaderboard-card.rank-3 {\n  border: 2px solid rgba(205, 127, 50, 0.5);\n  background: linear-gradient(135deg, rgba(205, 127, 50, 0.1), transparent);\n}\n\n.card-rank {\n  position: absolute;\n  top: 16px;\n  left: 16px;\n}\n\n.rank-badge-large {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 48px;\n  height: 48px;\n  border-radius: 48px;\n  font-size: 20px;\n  font-weight: 700;\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.rank-badge-large.rank-1 {\n  background: linear-gradient(135deg, #ffd700, #ffb347);\n  color: #000;\n}\n\n.rank-badge-large.rank-2 {\n  background: linear-gradient(135deg, #c0c0c0, #a0a0a0);\n  color: #000;\n}\n\n.rank-badge-large.rank-3 {\n  background: linear-gradient(135deg, #cd7f32, #b87333);\n  color: #fff;\n}\n\n.crown-decoration {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  font-size: 24px;\n  opacity: 0.5;\n}\n\n.card-avatar {\n  margin: 40px 0 16px;\n}\n\n.avatar-large {\n  width: 80px;\n  height: 80px;\n  background: linear-gradient(135deg, #8b5cf6, #ec489a);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 32px;\n  font-weight: 700;\n  color: white;\n  margin: 0 auto;\n  box-shadow: 0 4px 20px rgba(139, 92, 246, 0.3);\n}\n\n.card-name {\n  font-size: 18px;\n  font-weight: 700;\n  color: white;\n  margin-bottom: 20px;\n}\n\n.card-stats {\n  display: flex;\n  justify-content: space-around;\n  margin-bottom: 20px;\n  padding: 12px;\n  background: rgba(0, 0, 0, 0.3);\n  border-radius: 16px;\n}\n\n.stat-group {\n  text-align: center;\n}\n\n.stat-group .stat-label {\n  font-size: 10px;\n  color: rgba(255, 255, 255, 0.5);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  margin-bottom: 4px;\n}\n\n.stat-group .stat-value {\n  font-size: 20px;\n  font-weight: 700;\n  color: white;\n}\n\n.stat-group .stat-value.wins {\n  color: #10b981;\n}\n\n.stat-group .stat-value.losses {\n  color: #f87171;\n}\n\n.stat-divider {\n  width: 1px;\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.card-winrate {\n  margin-top: 16px;\n}\n\n.winrate-label {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.5);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  margin-bottom: 8px;\n}\n\n.winrate-bar-container {\n  position: relative;\n  height: 8px;\n  background: rgba(0, 0, 0, 0.3);\n  border-radius: 4px;\n  overflow: hidden;\n  margin-bottom: 8px;\n}\n\n.winrate-percent {\n  font-size: 14px;\n  font-weight: 600;\n  color: white;\n  text-align: center;\n}\n\n/* Leaderboard Footer */\n.leaderboard-footer {\n  background: rgba(255, 255, 255, 0.05);\n  backdrop-filter: blur(10px);\n  border-radius: 20px;\n  padding: 20px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  margin-top: 24px;\n}\n\n.footer-stats {\n  display: flex;\n  justify-content: space-around;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.footer-stats span {\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.7);\n  padding: 8px 16px;\n  background: rgba(0, 0, 0, 0.3);\n  border-radius: 20px;\n}\n\n/* Responsive */\n@media (max-width: 1024px) {\n  .leaderboard-table th,\n  .leaderboard-table td {\n    padding: 12px 16px;\n  }\n  \n  .rank-cell {\n    width: 60px;\n  }\n  \n  .wins-cell, .losses-cell, .games-cell {\n    width: 80px;\n  }\n}\n\n@media (max-width: 768px) {\n  .leaderboard-filters {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  \n  .filter-group {\n    justify-content: space-between;\n  }\n  \n  .view-toggle {\n    margin-left: auto;\n  }\n  \n  .leaderboard-table th,\n  .leaderboard-table td {\n    padding: 10px 12px;\n    font-size: 12px;\n  }\n  \n  .player-avatar {\n    width: 28px;\n    height: 28px;\n    font-size: 12px;\n  }\n  \n  .rank-badge {\n    width: 32px;\n    height: 32px;\n    font-size: 12px;\n  }\n  \n  .wins-badge, .losses-badge {\n    padding: 2px 8px;\n    font-size: 11px;\n  }\n  \n  .winrate-value {\n    font-size: 10px;\n    padding: 0 8px;\n  }\n  \n  .footer-stats {\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  .leaderboard-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  /* Hide some columns on mobile */\n  .games-col, .games-cell {\n    display: none;\n  }\n}\n\n@media (max-width: 640px) {\n  .losses-col, .losses-cell {\n    display: none;\n  }\n  \n  .winrate-col, .winrate-cell {\n    min-width: 140px;\n  }\n}\n\n/* Chess Lobby Styles */\n\n.chess-lobby-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 32px;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n/* User Stats Card */\n.user-stats-card {\n  background: linear-gradient(135deg, rgba(139, 92, 246, 0.2), rgba(236, 72, 153, 0.2));\n  backdrop-filter: blur(10px);\n  border-radius: 24px;\n  padding: 20px 24px;\n  margin-bottom: 32px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.stats-row {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 20px;\n}\n\n.stat-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.stat-icon {\n  font-size: 28px;\n}\n\n.stat-info {\n  display: flex;\n  flex-direction: column;\n}\n\n.stat-label {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.6);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.stat-value {\n  font-size: 18px;\n  font-weight: 700;\n  color: white;\n}\n\n.stat-divider {\n  width: 1px;\n  height: 40px;\n  background: rgba(255, 255, 255, 0.2);\n}\n\n/* Quick Actions Card */\n.quick-actions-card {\n  background: rgba(255, 255, 255, 0.05);\n  backdrop-filter: blur(10px);\n  border-radius: 24px;\n  padding: 24px;\n  margin-bottom: 32px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.quick-actions-row {\n  display: flex;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.quick-action {\n  flex: 1;\n  background: linear-gradient(135deg, #8b5cf6, #ec489a);\n  border: none;\n  border-radius: 40px;\n  padding: 14px 24px;\n  color: white;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.quick-action.searching {\n  background: rgba(255, 255, 255, 0.1);\n  cursor: wait;\n}\n\n.quick-action:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 15px rgba(139, 92, 246, 0.4);\n}\n\n.join-by-code {\n  display: flex;\n  gap: 12px;\n  flex: 1;\n}\n\n.code-input {\n  flex: 1;\n  background: rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 40px;\n  padding: 12px 20px;\n  color: white;\n  font-size: 14px;\n}\n\n.code-input:focus {\n  outline: none;\n  border-color: #8b5cf6;\n}\n\n.join-btn {\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 40px;\n  padding: 12px 24px;\n  color: white;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.join-btn:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.join-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.match-found {\n  margin-top: 16px;\n  padding: 10px 16px;\n  background: rgba(16, 185, 129, 0.2);\n  border-radius: 12px;\n  color: #10b981;\n  font-size: 13px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* Create Challenges */\n.create-challenges {\n  margin-bottom: 40px;\n}\n\n.create-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 16px;\n}\n\n.create-card {\n  background: rgba(255, 255, 255, 0.05);\n  backdrop-filter: blur(10px);\n  border-radius: 20px;\n  padding: 20px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.create-card:hover {\n  transform: translateY(-2px);\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.create-card.bot:hover {\n  border-color: #8b5cf6;\n}\n\n.create-card.friendly:hover {\n  border-color: #10b981;\n}\n\n.create-card.real:hover {\n  border-color: #fbbf24;\n}\n\n.create-icon {\n  font-size: 40px;\n}\n\n.create-info {\n  flex: 1;\n}\n\n.create-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: white;\n}\n\n.create-desc {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.6);\n  margin-top: 4px;\n}\n\n.create-arrow {\n  font-size: 20px;\n  color: rgba(255, 255, 255, 0.5);\n  transition: transform 0.3s ease;\n}\n\n.create-card:hover .create-arrow {\n  transform: translateX(4px);\n}\n\n/* Matches Section */\n.matches-section {\n  background: rgba(255, 255, 255, 0.05);\n  backdrop-filter: blur(10px);\n  border-radius: 24px;\n  padding: 24px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.matches-tabs {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 24px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  padding-bottom: 16px;\n}\n\n.tab-btn {\n  background: transparent;\n  border: none;\n  padding: 10px 20px;\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  border-radius: 40px;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.tab-btn.active {\n  background: linear-gradient(135deg, #8b5cf6, #ec489a);\n  color: white;\n}\n\n.tab-count {\n  background: rgba(0, 0, 0, 0.3);\n  padding: 2px 8px;\n  border-radius: 20px;\n  font-size: 11px;\n}\n\n.tab-btn.active .tab-count {\n  background: rgba(0, 0, 0, 0.5);\n}\n\n/* Matches List */\n.matches-group {\n  margin-bottom: 24px;\n}\n\n.group-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.7);\n  margin-bottom: 12px;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.matches-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.match-card {\n  background: rgba(0, 0, 0, 0.3);\n  border-radius: 20px;\n  padding: 20px;\n  transition: all 0.3s ease;\n}\n\n.match-card:hover {\n  transform: translateX(4px);\n  background: rgba(0, 0, 0, 0.4);\n}\n\n.match-card.available {\n  border-left: 3px solid #10b981;\n}\n\n.match-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.match-id {\n  font-family: monospace;\n  font-size: 12px;\n  color: #a78bfa;\n  background: rgba(139, 92, 246, 0.2);\n  padding: 4px 12px;\n  border-radius: 20px;\n}\n\n.match-badges {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.mode-badge {\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.mode-badge.friendly {\n  background: rgba(16, 185, 129, 0.2);\n  color: #10b981;\n}\n\n.mode-badge.real {\n  background: rgba(251, 191, 36, 0.2);\n  color: #fbbf24;\n}\n\n.wager-badge {\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 600;\n  background: rgba(239, 68, 68, 0.2);\n  color: #f87171;\n}\n\n.status-badge {\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.status-badge.pending {\n  background: rgba(251, 191, 36, 0.2);\n  color: #fbbf24;\n}\n\n.status-badge.ongoing {\n  background: rgba(16, 185, 129, 0.2);\n  color: #10b981;\n}\n\n.status-badge.completed {\n  background: rgba(107, 114, 128, 0.2);\n  color: #9ca3af;\n}\n\n/* Match Players */\n.match-players {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n}\n\n.player {\n  flex: 1;\n  text-align: center;\n}\n\n.player-role {\n  display: block;\n  font-size: 10px;\n  color: rgba(255, 255, 255, 0.5);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  margin-bottom: 4px;\n}\n\n.player-name {\n  font-size: 16px;\n  font-weight: 600;\n  color: white;\n}\n\n.player-name.waiting {\n  color: rgba(255, 255, 255, 0.5);\n  font-style: italic;\n}\n\n.vs-divider {\n  font-size: 12px;\n  font-weight: 700;\n  color: rgba(255, 255, 255, 0.5);\n  padding: 0 8px;\n}\n\n.match-details {\n  display: flex;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-bottom: 16px;\n  padding: 12px;\n  background: rgba(0, 0, 0, 0.2);\n  border-radius: 12px;\n}\n\n.detail-item {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.match-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n}\n\n.action-btn {\n  padding: 8px 20px;\n  border-radius: 40px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border: none;\n}\n\n.action-btn.cancel {\n  background: rgba(239, 68, 68, 0.2);\n  color: #f87171;\n}\n\n.action-btn.cancel:hover {\n  background: rgba(239, 68, 68, 0.3);\n}\n\n.action-btn.play, .action-btn.join {\n  background: linear-gradient(135deg, #8b5cf6, #ec489a);\n  color: white;\n}\n\n.action-btn.watch {\n  background: rgba(255, 255, 255, 0.1);\n  color: white;\n}\n\n.action-btn.play:hover, .action-btn.join:hover, .action-btn.watch:hover {\n  transform: translateY(-2px);\n}\n\n/* Search Bar */\n.search-bar {\n  position: relative;\n  margin-bottom: 20px;\n}\n\n.search-bar .search-icon {\n  position: absolute;\n  left: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 16px;\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.search-bar .search-input {\n  width: 100%;\n  background: rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 40px;\n  padding: 12px 16px 12px 40px;\n  color: white;\n  font-size: 14px;\n}\n\n.search-bar .search-input:focus {\n  outline: none;\n  border-color: #8b5cf6;\n}\n\n.clear-search {\n  position: absolute;\n  right: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  color: rgba(255, 255, 255, 0.5);\n  font-size: 18px;\n  cursor: pointer;\n}\n\n/* Time Options */\n.time-options {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.time-option {\n  flex: 1;\n  background: rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 12px;\n  padding: 12px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n}\n\n.time-option.selected {\n  border-color: #8b5cf6;\n  background: rgba(139, 92, 246, 0.2);\n}\n\n.time-icon {\n  font-size: 20px;\n}\n\n.time-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: white;\n}\n\n/* Wager Input */\n.wager-input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.wager-currency {\n  position: absolute;\n  left: 14px;\n  font-size: 16px;\n}\n\n.wager-input {\n  padding-left: 40px !important;\n  padding-right: 60px !important;\n  background: rgba(15, 23, 42, 0.9) !important;\n  background-color: rgba(15, 23, 42, 0.9) !important;\n  border: 1px solid rgba(148, 163, 184, 0.45) !important;\n  color: #f8fafc !important;\n  -webkit-text-fill-color: #f8fafc !important;\n  caret-color: #f8fafc !important;\n  box-shadow: none !important;\n  opacity: 1 !important;\n  font-weight: 700;\n  appearance: textfield;\n  -moz-appearance: textfield;\n  color-scheme: dark;\n}\n\n.wager-input::placeholder {\n  color: rgba(203, 213, 225, 0.85);\n}\n\n.wager-input:-webkit-autofill,\n.wager-input:-webkit-autofill:hover,\n.wager-input:-webkit-autofill:focus {\n  -webkit-text-fill-color: #f8fafc !important;\n  -webkit-box-shadow: 0 0 0 1000px rgba(15, 23, 42, 0.9) inset !important;\n  box-shadow: 0 0 0 1000px rgba(15, 23, 42, 0.9) inset !important;\n  background-color: rgba(15, 23, 42, 0.9) !important;\n}\n\n.wager-suffix {\n  position: absolute;\n  right: 14px;\n  color: rgba(255, 255, 255, 0.5);\n  font-size: 13px;\n}\n\n/* Error Hint */\n.error-hint {\n  margin-top: 8px;\n  font-size: 12px;\n  color: #f87171;\n}\n\n/* Chess Modal */\n.chess-modal {\n  max-width: 500px;\n}\n\n/* Spinner Small */\n.spinner-small {\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top-color: white;\n  border-radius: 50%;\n  animation: spin 0.6s linear infinite;\n  display: inline-block;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .stats-row {\n    flex-direction: column;\n    gap: 16px;\n  }\n  \n  .stat-divider {\n    display: none;\n  }\n  \n  .quick-actions-row {\n    flex-direction: column;\n  }\n  \n  .join-by-code {\n    flex-direction: column;\n  }\n  \n  .match-players {\n    flex-direction: column;\n    text-align: center;\n  }\n  \n  .vs-divider {\n    display: none;\n  }\n  \n  .match-actions {\n    justify-content: center;\n  }\n  \n  .time-options {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  \n  .create-cards {\n    grid-template-columns: 1fr;\n  }\n\n  .tab-btn .tab-text {\n    display: none;\n  }\n}\n\n\n/* Transactions Page Styles */\n\n.transactions-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 32px;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.header-icon {\n  font-size: 48px;\n  background: linear-gradient(135deg, #8b5cf6, #ec489a);\n  width: 64px;\n  height: 64px;\n  border-radius: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 32px;\n}\n\n.page-title {\n  font-size: 32px;\n  font-weight: 800;\n  color: white;\n  margin: 0;\n}\n\n.page-subtitle {\n  color: rgba(255, 255, 255, 0.6);\n  margin: 4px 0 0;\n}\n\n.back-btn {\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 40px;\n  padding: 10px 20px;\n  color: white;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.back-btn:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n/* Balance Card */\n.balance-card {\n  background: linear-gradient(135deg, rgba(139, 92, 246, 0.2), rgba(236, 72, 153, 0.2));\n  backdrop-filter: blur(10px);\n  border-radius: 32px;\n  padding: 32px;\n  margin-bottom: 32px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 20px;\n}\n\n.balance-label {\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.6);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.balance-value {\n  font-size: 48px;\n  font-weight: 800;\n  color: white;\n  margin-top: 8px;\n}\n\n.balance-actions {\n  display: flex;\n  gap: 12px;\n}\n\n.balance-action {\n  padding: 12px 24px;\n  border-radius: 40px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border: none;\n}\n\n.balance-action.deposit {\n  background: linear-gradient(135deg, #10b981, #059669);\n  color: white;\n}\n\n.balance-action.deposit.active {\n  background: linear-gradient(135deg, #059669, #047857);\n  box-shadow: 0 4px 15px rgba(16, 185, 129, 0.3);\n}\n\n.balance-action.withdraw {\n  background: rgba(255, 255, 255, 0.1);\n  color: white;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.balance-action.withdraw.active {\n  background: rgba(255, 255, 255, 0.2);\n  border-color: rgba(255, 255, 255, 0.3);\n}\n\n/* Transaction Cards */\n.transaction-card {\n  background: rgba(255, 255, 255, 0.05);\n  backdrop-filter: blur(10px);\n  border-radius: 32px;\n  padding: 32px;\n  margin-bottom: 32px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.card-header {\n  margin-bottom: 24px;\n}\n\n.card-title {\n  font-size: 24px;\n  font-weight: 700;\n  color: white;\n  margin: 0;\n}\n\n.card-subtitle {\n  color: rgba(255, 255, 255, 0.6);\n  margin: 4px 0 0;\n}\n\n/* Provider Selector */\n.provider-selector {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 16px;\n  margin-bottom: 32px;\n}\n\n.provider-option {\n  background: rgba(0, 0, 0, 0.3);\n  border: 2px solid rgba(255, 255, 255, 0.1);\n  border-radius: 20px;\n  padding: 20px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: relative;\n}\n\n.provider-option.selected {\n  border-color: #8b5cf6;\n  background: rgba(139, 92, 246, 0.1);\n}\n\n.provider-icon {\n  font-size: 32px;\n}\n\n.provider-info {\n  flex: 1;\n}\n\n.provider-name {\n  font-size: 16px;\n  font-weight: 600;\n  color: white;\n}\n\n.provider-desc {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.6);\n  margin-top: 4px;\n}\n\n.provider-check {\n  width: 24px;\n  height: 24px;\n  background: #8b5cf6;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 14px;\n}\n\n/* Forms */\n.deposit-form, .withdraw-form {\n  max-width: 500px;\n}\n\n.form-group {\n  margin-bottom: 24px;\n}\n\n.form-label {\n  display: block;\n  font-size: 14px;\n  font-weight: 600;\n  color: white;\n  margin-bottom: 8px;\n}\n\n.form-input, .form-select {\n  width: 100%;\n  background: rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 12px;\n  padding: 14px 16px;\n  color: white;\n  font-size: 16px;\n  transition: all 0.3s ease;\n}\n\n.form-input:focus, .form-select:focus {\n  outline: none;\n  border-color: #8b5cf6;\n}\n\n.form-hint {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.5);\n  margin-top: 6px;\n}\n\n.amount-input-wrapper {\n  position: relative;\n}\n\n.amount-input {\n  width: 100%;\n  background: rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 12px;\n  padding: 14px 16px;\n  color: white;\n  font-size: 24px;\n  font-weight: 600;\n  text-align: center;\n}\n\n.amount-suggestions {\n  display: flex;\n  gap: 8px;\n  margin-top: 12px;\n  justify-content: center;\n}\n\n.suggestion {\n  background: rgba(255, 255, 255, 0.1);\n  border: none;\n  border-radius: 20px;\n  padding: 6px 12px;\n  color: white;\n  font-size: 12px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.suggestion:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n/* Network Selector */\n.network-selector {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 12px;\n}\n\n.network-option {\n  background: rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n  padding: 12px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-align: left;\n}\n\n.network-option.selected {\n  border-color: #8b5cf6;\n  background: rgba(139, 92, 246, 0.1);\n}\n\n.network-icon {\n  font-size: 20px;\n  display: block;\n  margin-bottom: 8px;\n}\n\n.network-name {\n  display: block;\n  font-size: 14px;\n  font-weight: 600;\n  color: white;\n  margin-bottom: 4px;\n}\n\n.network-fee {\n  font-size: 10px;\n  color: rgba(255, 255, 255, 0.5);\n}\n\n/* Buttons */\n.deposit-btn, .withdraw-btn {\n  width: 100%;\n  background: linear-gradient(135deg, #8b5cf6, #ec489a);\n  border: none;\n  border-radius: 40px;\n  padding: 14px;\n  color: white;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-top: 8px;\n}\n\n.deposit-btn:hover:not(:disabled), .withdraw-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 15px rgba(139, 92, 246, 0.4);\n}\n\n.deposit-btn:disabled, .withdraw-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.recheck-btn {\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 40px;\n  padding: 10px 20px;\n  color: white;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-top: 16px;\n  width: 100%;\n}\n\n.recheck-btn:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n/* Messages */\n.message {\n  padding: 12px 16px;\n  border-radius: 12px;\n  margin-top: 16px;\n  font-size: 14px;\n}\n\n.message.success {\n  background: rgba(16, 185, 129, 0.2);\n  border: 1px solid rgba(16, 185, 129, 0.5);\n  color: #10b981;\n}\n\n.message.error {\n  background: rgba(239, 68, 68, 0.2);\n  border: 1px solid rgba(239, 68, 68, 0.5);\n  color: #f87171;\n}\n\n.message.info {\n  background: rgba(139, 92, 246, 0.2);\n  border: 1px solid rgba(139, 92, 246, 0.5);\n  color: #a78bfa;\n}\n\n/* Admin Section */\n.admin-section {\n  margin-bottom: 32px;\n}\n\n.admin-card {\n  background: rgba(255, 255, 255, 0.05);\n  backdrop-filter: blur(10px);\n  border-radius: 32px;\n  padding: 32px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.mode-controls {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 20px;\n  margin-bottom: 32px;\n  padding-bottom: 24px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.mode-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.mode-label {\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 14px;\n}\n\n.mode-value {\n  font-size: 14px;\n  font-weight: 600;\n  padding: 6px 12px;\n  border-radius: 20px;\n}\n\n.mode-value.admin_approve {\n  background: rgba(239, 68, 68, 0.2);\n  color: #f87171;\n}\n\n.mode-value.auto {\n  background: rgba(16, 185, 129, 0.2);\n  color: #10b981;\n}\n\n.mode-actions {\n  display: flex;\n  gap: 12px;\n}\n\n.mode-btn {\n  padding: 8px 20px;\n  border-radius: 40px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border: none;\n  background: rgba(255, 255, 255, 0.1);\n  color: white;\n}\n\n.mode-btn.active {\n  background: linear-gradient(135deg, #8b5cf6, #ec489a);\n}\n\n.mode-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n}\n\n/* Pending Withdrawals */\n.pending-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: white;\n  margin-bottom: 16px;\n}\n\n.pending-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.pending-item {\n  background: rgba(0, 0, 0, 0.3);\n  border-radius: 16px;\n  padding: 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.pending-info {\n  flex: 1;\n}\n\n.pending-user {\n  font-weight: 600;\n  color: white;\n  margin-bottom: 4px;\n}\n\n.pending-amount {\n  font-size: 14px;\n  color: #fbbf24;\n  margin-bottom: 4px;\n}\n\n.pending-address {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.5);\n  font-family: monospace;\n}\n\n.pending-actions {\n  display: flex;\n  gap: 12px;\n}\n\n.approve-btn, .reject-btn {\n  padding: 8px 20px;\n  border-radius: 40px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border: none;\n}\n\n.approve-btn {\n  background: linear-gradient(135deg, #10b981, #059669);\n  color: white;\n}\n\n.reject-btn {\n  background: rgba(239, 68, 68, 0.2);\n  color: #f87171;\n  border: 1px solid rgba(239, 68, 68, 0.5);\n}\n\n.approve-btn:hover:not(:disabled), .reject-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n}\n\n/* Filters Section */\n.filters-section {\n  background: rgba(255, 255, 255, 0.05);\n  backdrop-filter: blur(10px);\n  border-radius: 32px;\n  padding: 32px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.filters-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.filters-title {\n  font-size: 20px;\n  font-weight: 700;\n  color: white;\n  margin: 0;\n}\n\n.filters-controls {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.filter-select {\n  background: rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 40px;\n  padding: 8px 16px;\n  color: white;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n/* Transactions List */\n.transactions-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.transaction-item {\n  background: rgba(0, 0, 0, 0.3);\n  border-radius: 16px;\n  padding: 16px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  transition: all 0.3s ease;\n}\n\n.transaction-item:hover {\n  background: rgba(0, 0, 0, 0.4);\n  transform: translateX(4px);\n}\n\n.transaction-icon {\n  width: 48px;\n  height: 48px;\n  background: rgba(139, 92, 246, 0.2);\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 24px;\n}\n\n.transaction-icon:empty::before {\n  content: '↩️';\n}\n\n.transaction-info {\n  flex: 1;\n}\n\n.transaction-category {\n  font-size: 14px;\n  font-weight: 600;\n  color: white;\n  text-transform: capitalize;\n}\n\n.transaction-game {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.5);\n  font-weight: normal;\n}\n\n.transaction-desc {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.5);\n  margin-top: 4px;\n}\n\n.transaction-date {\n  font-size: 10px;\n  color: rgba(255, 255, 255, 0.4);\n  margin-top: 4px;\n}\n\n.transaction-amount {\n  font-size: 18px;\n  font-weight: 700;\n  min-width: 80px;\n  text-align: right;\n}\n\n.transaction-balance {\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.6);\n  min-width: 80px;\n  text-align: right;\n}\n\n/* Deposit History */\n.deposit-history {\n  margin-top: 32px;\n  padding-top: 24px;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n/* Withdrawal History */\n.withdrawal-history {\n  margin-top: 32px;\n  padding-top: 24px;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.history-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: white;\n  margin-bottom: 16px;\n}\n\n.history-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.history-item {\n  background: rgba(0, 0, 0, 0.3);\n  border-radius: 12px;\n  padding: 12px 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.history-amount {\n  font-size: 16px;\n  font-weight: 600;\n  color: white;\n}\n\n.history-date {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.4);\n  margin-top: 4px;\n}\n\n.history-details {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.history-status {\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.history-status.status-pending {\n  background: rgba(251, 191, 36, 0.2);\n  color: #fbbf24;\n}\n\n.history-status.status-completed, .history-status.status-success {\n  background: rgba(16, 185, 129, 0.2);\n  color: #10b981;\n}\n\n.history-status.status-failed, .history-status.status-rejected {\n  background: rgba(239, 68, 68, 0.2);\n  color: #f87171;\n}\n\n.history-network {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.5);\n  font-family: monospace;\n}\n\n/* Loading & Empty States */\n.loading-state, .error-state, .empty-state {\n  text-align: center;\n  padding: 48px;\n}\n\n.spinner {\n  width: 24px;\n  height: 24px;\n  border: 2px solid rgba(255, 255, 255, 0.2);\n  border-top-color: #8b5cf6;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n  display: inline-block;\n  margin-right: 8px;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n.empty-icon {\n  font-size: 48px;\n  margin-bottom: 16px;\n  opacity: 0.5;\n}\n\n.empty-text {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.error-icon {\n  font-size: 24px;\n  margin-right: 8px;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .balance-value {\n    font-size: 32px;\n  }\n  \n  .transaction-item {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .transaction-amount, .transaction-balance {\n    text-align: left;\n    width: 100%;\n  }\n  \n  .pending-item {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .pending-actions {\n    width: 100%;\n  }\n  \n  .approve-btn, .reject-btn {\n    flex: 1;\n    text-align: center;\n  }\n  \n  .mode-controls {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .filters-controls {\n    width: 100%;\n  }\n  \n  .filter-select {\n    flex: 1;\n  }\n  \n  .network-selector {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* History Page Styles */\n\n.history-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 32px;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n/* Stats Overview */\n.stats-overview {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin-bottom: 32px;\n}\n\n.stats-overview .stat-card {\n  background: rgba(255, 255, 255, 0.05);\n  backdrop-filter: blur(10px);\n  border-radius: 20px;\n  padding: 20px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  min-width: 120px;\n}\n\n.stats-overview .stat-card.total {\n  background: linear-gradient(135deg, rgba(139, 92, 246, 0.2), rgba(236, 72, 153, 0.2));\n  border-left: 4px solid #8b5cf6;\n}\n\n.stats-overview .stat-card .stat-value {\n  font-size: 28px;\n  font-weight: 800;\n  color: white;\n}\n\n.stats-overview .stat-card .stat-label {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.6);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.stats-overview .stat-card .stat-icon {\n  font-size: 32px;\n}\n\n.stats-overview .stat-card .stat-info {\n  display: flex;\n  flex-direction: column;\n}\n\n/* Filters Card */\n.filters-card {\n  background: rgba(255, 255, 255, 0.05);\n  backdrop-filter: blur(10px);\n  border-radius: 24px;\n  padding: 24px;\n  margin-bottom: 32px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.filters-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.filters-row:last-child {\n  margin-bottom: 0;\n}\n\n/* Search Wrapper */\n.search-wrapper {\n  position: relative;\n  flex: 1;\n  min-width: 250px;\n}\n\n.search-icon {\n  position: absolute;\n  left: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 16px;\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.search-wrapper .search-input {\n  width: 100%;\n  background: rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 40px;\n  padding: 12px 16px 12px 40px;\n  color: white;\n  font-size: 14px;\n  transition: all 0.3s ease;\n}\n\n.search-wrapper .search-input:focus {\n  outline: none;\n  border-color: #8b5cf6;\n}\n\n.clear-search {\n  position: absolute;\n  right: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  color: rgba(255, 255, 255, 0.5);\n  font-size: 18px;\n  cursor: pointer;\n  padding: 0;\n}\n\n.clear-search:hover {\n  color: white;\n}\n\n/* View Toggle */\n.view-toggle {\n  display: flex;\n  gap: 8px;\n  background: rgba(0, 0, 0, 0.3);\n  border-radius: 40px;\n  padding: 4px;\n}\n\n.view-btn {\n  background: transparent;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 40px;\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.view-btn.active {\n  background: linear-gradient(135deg, #8b5cf6, #ec489a);\n  color: white;\n}\n\n.view-btn:hover:not(.active) {\n  background: rgba(255, 255, 255, 0.1);\n  color: white;\n}\n\n/* Category Filters */\n.category-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  flex: 1;\n}\n\n.category-filter {\n  background: rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 40px;\n  padding: 8px 16px;\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.category-filter:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: white;\n}\n\n.category-filter.active {\n  background: var(--category-color, #8b5cf6);\n  border-color: var(--category-color, #8b5cf6);\n  color: white;\n}\n\n.filter-icon {\n  font-size: 14px;\n}\n\n.filter-count {\n  background: rgba(0, 0, 0, 0.5);\n  border-radius: 20px;\n  padding: 2px 6px;\n  font-size: 10px;\n  margin-left: 4px;\n}\n\n.category-filter.active .filter-count {\n  background: rgba(0, 0, 0, 0.3);\n}\n\n/* Sort Select */\n.sort-select {\n  background: rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 40px;\n  padding: 8px 16px;\n  color: white;\n  font-size: 13px;\n  cursor: pointer;\n}\n\n/* Date Filters */\n.date-filters {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.date-input-group {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.date-input-group label {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.6);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.date-input {\n  background: rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 8px;\n  padding: 8px 12px;\n  color: white;\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.date-input:focus {\n  outline: none;\n  border-color: #8b5cf6;\n}\n\n.date-hint {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.filter-error {\n  margin-top: 12px;\n  padding: 10px;\n  background: rgba(239, 68, 68, 0.1);\n  border-radius: 8px;\n  color: #f87171;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* History List View */\n.history-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.history-item {\n  background: rgba(0, 0, 0, 0.3);\n  border-radius: 20px;\n  padding: 20px;\n  display: flex;\n  gap: 16px;\n  transition: all 0.3s ease;\n}\n\n.history-item:hover {\n  transform: translateX(4px);\n  background: rgba(0, 0, 0, 0.4);\n}\n\n.history-item-icon {\n  width: 56px;\n  height: 56px;\n  background: rgba(139, 92, 246, 0.2);\n  border-radius: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 28px;\n  border-left: 3px solid;\n  flex-shrink: 0;\n}\n\n.history-item-content {\n  flex: 1;\n}\n\n.history-item-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin-bottom: 8px;\n}\n\n.history-item-category {\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.history-item-id {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.4);\n  font-family: monospace;\n}\n\n.result-badge {\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.result-badge.win {\n  background: rgba(16, 185, 129, 0.2);\n  color: #10b981;\n}\n\n.result-badge.loss {\n  background: rgba(239, 68, 68, 0.2);\n  color: #f87171;\n}\n\n.result-badge.draw {\n  background: rgba(251, 191, 36, 0.2);\n  color: #fbbf24;\n}\n\n.result-badge.completed {\n  background: rgba(16, 185, 129, 0.2);\n  color: #10b981;\n}\n\n.result-badge.pending {\n  background: rgba(251, 191, 36, 0.2);\n  color: #fbbf24;\n}\n\n.result-badge.played {\n  background: rgba(139, 92, 246, 0.2);\n  color: #a78bfa;\n}\n\n.history-item-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: white;\n  margin-bottom: 4px;\n}\n\n.history-item-subtitle {\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.7);\n  margin-bottom: 4px;\n}\n\n.history-item-details {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.5);\n  margin-bottom: 8px;\n}\n\n.history-item-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-top: 8px;\n}\n\n.history-item-date {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.4);\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.view-details-btn {\n  background: rgba(139, 92, 246, 0.2);\n  border: 1px solid rgba(139, 92, 246, 0.3);\n  border-radius: 40px;\n  padding: 6px 16px;\n  color: #a78bfa;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.view-details-btn:hover {\n  background: rgba(139, 92, 246, 0.3);\n  transform: translateX(2px);\n}\n\n/* History Grid View */\n.history-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 20px;\n  margin-bottom: 24px;\n}\n\n.history-grid-item {\n  background: rgba(0, 0, 0, 0.3);\n  border-radius: 20px;\n  overflow: hidden;\n  transition: all 0.3s ease;\n}\n\n.history-grid-item:hover {\n  transform: translateY(-4px);\n  background: rgba(0, 0, 0, 0.4);\n}\n\n.grid-item-header {\n  padding: 16px;\n  border-top: 3px solid;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.grid-item-category {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.grid-category-icon {\n  font-size: 20px;\n}\n\n.grid-category-name {\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.grid-item-content {\n  padding: 16px;\n}\n\n.grid-item-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: white;\n  margin-bottom: 8px;\n}\n\n.grid-item-subtitle {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.7);\n  margin-bottom: 4px;\n}\n\n.grid-item-details {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.grid-item-footer {\n  padding: 12px 16px;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.grid-item-date {\n  font-size: 10px;\n  color: rgba(255, 255, 255, 0.4);\n}\n\n.view-btn-small {\n  background: rgba(139, 92, 246, 0.2);\n  border: none;\n  border-radius: 20px;\n  padding: 4px 12px;\n  color: #a78bfa;\n  font-size: 11px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.view-btn-small:hover {\n  background: rgba(139, 92, 246, 0.3);\n}\n\n/* Results Summary */\n.results-summary {\n  text-align: center;\n  padding: 16px;\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.5);\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n/* Clear Filters Button */\n.clear-filters-btn {\n  margin-top: 20px;\n  background: rgba(139, 92, 246, 0.2);\n  border: 1px solid rgba(139, 92, 246, 0.3);\n  border-radius: 40px;\n  padding: 10px 24px;\n  color: #a78bfa;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.clear-filters-btn:hover {\n  background: rgba(139, 92, 246, 0.3);\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .filters-row {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  \n  .category-filters {\n    order: 1;\n  }\n  \n  .sort-select {\n    width: 100%;\n  }\n  \n  .date-filters {\n    width: 100%;\n  }\n  \n  .date-input-group {\n    flex: 1;\n  }\n  \n  .date-input {\n    width: 100%;\n  }\n  \n  .history-item {\n    flex-direction: column;\n  }\n  \n  .history-item-icon {\n    width: 48px;\n    height: 48px;\n    font-size: 24px;\n  }\n  \n  .history-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .stats-overview {\n    justify-content: center;\n  }\n  \n  .stats-overview .stat-card {\n    min-width: calc(33% - 12px);\n  }\n}\n\n@media (max-width: 480px) {\n  .stats-overview .stat-card {\n    min-width: 100%;\n  }\n  \n  .history-item-header {\n    flex-wrap: wrap;\n  }\n  \n  .history-item-footer {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .view-details-btn {\n    width: 100%;\n    text-align: center;\n  }\n}\n\n/* Admin Dashboard Specific Styles */\n\n/* Header Actions */\n.header-actions {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.logout-btn {\n  background: rgba(239, 68, 68, 0.2);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n  border-radius: 40px;\n  padding: 10px 20px;\n  color: #f87171;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.logout-btn:hover {\n  background: rgba(239, 68, 68, 0.3);\n  transform: translateY(-2px);\n}\n\n/* Stats Grid */\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n  margin-bottom: 32px;\n}\n\n.stats-grid .stat-card {\n  background: rgba(255, 255, 255, 0.05);\n  backdrop-filter: blur(10px);\n  border-radius: 20px;\n  padding: 20px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  transition: all 0.3s ease;\n}\n\n.stats-grid .stat-card:hover {\n  transform: translateY(-2px);\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.stats-grid .stat-icon {\n  font-size: 32px;\n}\n\n.stats-grid .stat-info {\n  flex: 1;\n}\n\n.stats-grid .stat-label {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.6);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.stats-grid .stat-value {\n  font-size: 24px;\n  font-weight: 700;\n  color: white;\n}\n\n/* Admin Card */\n.admin-card {\n  background: rgba(255, 255, 255, 0.05);\n  backdrop-filter: blur(10px);\n  border-radius: 32px;\n  padding: 32px;\n  margin-bottom: 32px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n/* Search Wrapper */\n.search-wrapper {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  position: relative;\n}\n\n.search-wrapper .search-input {\n  background: rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 40px;\n  padding: 12px 16px 12px 40px;\n  color: white;\n  font-size: 14px;\n  width: 300px;\n}\n\n.search-wrapper .search-icon {\n  position: absolute;\n  left: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 16px;\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.search-btn {\n  background: linear-gradient(135deg, #8b5cf6, #ec489a);\n  border: none;\n  border-radius: 40px;\n  padding: 10px 20px;\n  color: white;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.search-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.4);\n}\n\n/* Admin Table */\n.table-responsive {\n  overflow-x: auto;\n  margin-top: 20px;\n}\n\n.admin-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.admin-table th {\n  text-align: left;\n  padding: 12px;\n  color: rgba(255, 255, 255, 0.7);\n  font-weight: 600;\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.admin-table td {\n  padding: 12px;\n  color: rgba(255, 255, 255, 0.9);\n  font-size: 13px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.admin-table tr:hover {\n  background: rgba(255, 255, 255, 0.03);\n}\n\n/* User Name Cell */\n.user-name-cell {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.online-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #4b5563;\n  display: inline-block;\n}\n\n.online-dot.online {\n  background: #10b981;\n  box-shadow: 0 0 4px #10b981;\n}\n\n/* Role Badge */\n.role-badge {\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.role-badge.admin {\n  background: linear-gradient(135deg, #8b5cf6, #ec489a);\n  color: white;\n}\n\n.role-badge.user {\n  background: rgba(59, 130, 246, 0.2);\n  color: #60a5fa;\n}\n\n/* Status Badge */\n.status-badge {\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.status-badge.online {\n  background: rgba(16, 185, 129, 0.2);\n  color: #10b981;\n}\n\n.status-badge.offline {\n  background: rgba(107, 114, 128, 0.2);\n  color: #9ca3af;\n}\n\n.status-badge.blocked {\n  background: rgba(239, 68, 68, 0.2);\n  color: #f87171;\n}\n\n.status-badge.pending {\n  background: rgba(251, 191, 36, 0.2);\n  color: #fbbf24;\n}\n\n/* Category Badge */\n.category-badge {\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: capitalize;\n}\n\n.category-badge.deposit {\n  background: rgba(16, 185, 129, 0.2);\n  color: #10b981;\n}\n\n.category-badge.withdrawal {\n  background: rgba(239, 68, 68, 0.2);\n  color: #f87171;\n}\n\n.category-badge.wager {\n  background: rgba(139, 92, 246, 0.2);\n  color: #a78bfa;\n}\n\n.category-badge.payout {\n  background: rgba(251, 191, 36, 0.2);\n  color: #fbbf24;\n}\n\n/* Amount Cell */\n.amount-cell.positive {\n  color: #10b981;\n  font-weight: 600;\n}\n\n.amount-cell.negative {\n  color: #f87171;\n  font-weight: 600;\n}\n\n.balance-cell {\n  font-weight: 600;\n  color: white;\n}\n\n.date-cell {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.5);\n  white-space: nowrap;\n}\n\n/* Action Buttons */\n.actions-cell {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.action-btn {\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border: none;\n}\n\n.action-btn.view {\n  background: rgba(139, 92, 246, 0.2);\n  color: #a78bfa;\n}\n\n.action-btn.view:hover {\n  background: rgba(139, 92, 246, 0.3);\n}\n\n.action-btn.block {\n  background: rgba(239, 68, 68, 0.2);\n  color: #f87171;\n}\n\n.action-btn.block:hover {\n  background: rgba(239, 68, 68, 0.3);\n}\n\n.action-btn.unblock {\n  background: rgba(16, 185, 129, 0.2);\n  color: #10b981;\n}\n\n.action-btn.unblock:hover {\n  background: rgba(16, 185, 129, 0.3);\n}\n\n.action-btn.approve {\n  background: rgba(16, 185, 129, 0.2);\n  color: #10b981;\n}\n\n.action-btn.reject {\n  background: rgba(239, 68, 68, 0.2);\n  color: #f87171;\n}\n\n/* Pagination */\n.pagination-bar {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 16px;\n  margin-top: 24px;\n  padding-top: 16px;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.pagination-btn {\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 40px;\n  padding: 8px 20px;\n  color: white;\n  font-size: 13px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.pagination-btn:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.pagination-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.pagination-info {\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 13px;\n}\n\n/* Export Button */\n.export-btn {\n  background: rgba(139, 92, 246, 0.2);\n  border: 1px solid rgba(139, 92, 246, 0.3);\n  border-radius: 40px;\n  padding: 8px 20px;\n  color: #a78bfa;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.export-btn:hover:not(:disabled) {\n  background: rgba(139, 92, 246, 0.3);\n}\n\n/* Balance Form */\n.balance-form {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n  align-items: end;\n}\n\n.balance-form .form-group {\n  margin-bottom: 0;\n}\n\n.balance-form .save-btn {\n  margin-top: 0;\n  padding: 12px 24px;\n}\n\n/* Settings Grid */\n.settings-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 20px;\n  margin-bottom: 32px;\n}\n\n.setting-item {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.setting-item label {\n  font-size: 12px;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.7);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.setting-item input {\n  background: rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 12px;\n  padding: 10px 14px;\n  color: white;\n  font-size: 14px;\n}\n\n.setting-item input:focus {\n  outline: none;\n  border-color: #8b5cf6;\n}\n\n/* Distribution Section */\n.distribution-section {\n  margin-top: 32px;\n  padding-top: 24px;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.section-subtitle {\n  font-size: 16px;\n  font-weight: 600;\n  color: white;\n  margin-bottom: 20px;\n}\n\n.distribution-block {\n  background: rgba(0, 0, 0, 0.2);\n  border-radius: 20px;\n  padding: 16px;\n  margin-bottom: 16px;\n}\n\n.distribution-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.distribution-header h4 {\n  font-size: 14px;\n  font-weight: 600;\n  color: white;\n  margin: 0;\n}\n\n.distribution-total {\n  font-size: 12px;\n  padding: 4px 10px;\n  border-radius: 20px;\n}\n\n.distribution-total.valid {\n  background: rgba(16, 185, 129, 0.2);\n  color: #10b981;\n}\n\n.distribution-total.invalid {\n  background: rgba(239, 68, 68, 0.2);\n  color: #f87171;\n}\n\n.distribution-inputs {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));\n  gap: 12px;\n}\n\n.distribution-input {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.distribution-input label {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.distribution-input input {\n  background: rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 8px;\n  padding: 8px 10px;\n  color: white;\n  font-size: 13px;\n  text-align: center;\n}\n\n/* Mode Controls */\n.mode-controls {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin-bottom: 24px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.mode-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.mode-label {\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.mode-value {\n  padding: 6px 14px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.mode-value.admin_approve {\n  background: rgba(239, 68, 68, 0.2);\n  color: #f87171;\n}\n\n.mode-value.auto {\n  background: rgba(16, 185, 129, 0.2);\n  color: #10b981;\n}\n\n.mode-actions {\n  display: flex;\n  gap: 12px;\n}\n\n.mode-btn {\n  background: rgba(255, 255, 255, 0.1);\n  border: none;\n  border-radius: 40px;\n  padding: 8px 20px;\n  color: white;\n  font-size: 13px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.mode-btn.active {\n  background: linear-gradient(135deg, #8b5cf6, #ec489a);\n}\n\n.mode-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n}\n\n.refresh-btn-small {\n  background: rgba(255, 255, 255, 0.1);\n  border: none;\n  border-radius: 40px;\n  padding: 8px 16px;\n  color: white;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n/* Reconcile Controls */\n.reconcile-controls {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.reconcile-option {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.reconcile-option label {\n  font-size: 11px;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.6);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.reconcile-option select,\n.reconcile-option input {\n  background: rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 10px;\n  padding: 8px 12px;\n  color: white;\n  font-size: 13px;\n}\n\n/* Admin Actions */\n.admin-actions {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n  flex-wrap: wrap;\n  margin-top: 24px;\n}\n\n.dryrun-btn, .recover-btn {\n  padding: 10px 24px;\n  border-radius: 40px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border: none;\n}\n\n.dryrun-btn {\n  background: rgba(255, 255, 255, 0.1);\n  color: white;\n}\n\n.recover-btn {\n  background: linear-gradient(135deg, #ef4444, #dc2626);\n  color: white;\n}\n\n.dryrun-btn:hover:not(:disabled),\n.recover-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n}\n\n.error-hint {\n  font-size: 12px;\n  color: #f87171;\n}\n\n/* Reconcile Summary */\n.reconcile-summary {\n  background: rgba(0, 0, 0, 0.3);\n  border-radius: 16px;\n  padding: 16px;\n  margin-top: 20px;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 12px;\n}\n\n.summary-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.summary-label {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.5);\n  text-transform: uppercase;\n}\n\n.summary-value {\n  font-size: 16px;\n  font-weight: 700;\n  color: white;\n}\n\n/* Profile Modal */\n.profile-modal {\n  background: linear-gradient(135deg, #1e1b4b, #0f172a);\n  border-radius: 32px;\n  max-width: 600px;\n  width: 90%;\n  max-height: 80vh;\n  overflow-y: auto;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.profile-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 16px;\n  padding: 20px;\n}\n\n.profile-field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.field-label {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.5);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.field-value {\n  font-size: 14px;\n  font-weight: 600;\n  color: white;\n}\n\n.field-value.balance {\n  color: #fbbf24;\n  font-size: 18px;\n}\n\n.transactions-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: white;\n  padding: 0 20px;\n  margin-bottom: 12px;\n}\n\n.transactions-list {\n  padding: 0 20px 20px;\n}\n\n.transaction-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px;\n  background: rgba(0, 0, 0, 0.2);\n  border-radius: 10px;\n  margin-bottom: 8px;\n  font-size: 12px;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.transaction-date {\n  color: rgba(255, 255, 255, 0.5);\n  font-size: 10px;\n}\n\n.transaction-category {\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: capitalize;\n}\n\n.transaction-category.deposit {\n  background: rgba(16, 185, 129, 0.2);\n  color: #10b981;\n}\n\n.transaction-category.withdrawal {\n  background: rgba(239, 68, 68, 0.2);\n  color: #f87171;\n}\n\n.transaction-amount {\n  font-weight: 600;\n}\n\n.transaction-amount.positive {\n  color: #10b981;\n}\n\n.transaction-amount.negative {\n  color: #f87171;\n}\n\n.transaction-balance {\n  color: rgba(255, 255, 255, 0.6);\n}\n\n/* Empty State Small */\n.empty-state-small {\n  text-align: center;\n  padding: 20px;\n  color: rgba(255, 255, 255, 0.5);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n\n.empty-state-small .empty-icon {\n  font-size: 32px;\n  opacity: 0.5;\n}\n\n/* Address Cell */\n.address-cell {\n  font-family: monospace;\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n/* Empty Cell */\n.empty-cell {\n  text-align: center;\n  padding: 40px;\n  color: rgba(255, 255, 255, 0.5);\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  \n  .balance-form {\n    grid-template-columns: 1fr;\n  }\n  \n  .mode-controls {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .distribution-inputs {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  \n  .profile-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .actions-cell {\n    flex-direction: column;\n  }\n  \n  .search-wrapper {\n    width: 100%;\n  }\n  \n  .search-wrapper .search-input {\n    width: 100%;\n  }\n  \n  .admin-card {\n    padding: 20px;\n  }\n}\n\n/* Checkers Lobby Specific Styles */\n\n.checkers-icon {\n  font-size: 36px;\n  background: linear-gradient(135deg, #f59e0b, #ef4444);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n/* Time Options with Descriptions */\n.time-option {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  padding: 12px;\n  background: rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  min-width: 80px;\n}\n\n.time-option.selected {\n  border-color: #f59e0b;\n  background: rgba(245, 158, 11, 0.2);\n}\n\n.time-icon {\n  font-size: 20px;\n}\n\n.time-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: white;\n}\n\n.time-desc {\n  font-size: 9px;\n  color: rgba(255, 255, 255, 0.5);\n}\n\n/* Quick Action Button */\n.quick-action {\n  flex: 1;\n  background: linear-gradient(135deg, #f59e0b, #ef4444);\n  border: none;\n  border-radius: 40px;\n  padding: 14px 24px;\n  color: white;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.quick-action.searching {\n  background: rgba(255, 255, 255, 0.1);\n  cursor: wait;\n}\n\n.quick-action:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 15px rgba(245, 158, 11, 0.4);\n}\n\n/* Create Cards with Checkers Theme */\n.create-card.bot {\n  border-left: 3px solid #f59e0b;\n}\n\n.create-card.bot:hover {\n  border-color: #f59e0b;\n  box-shadow: 0 4px 20px rgba(245, 158, 11, 0.2);\n}\n\n.create-card.friendly {\n  border-left: 3px solid #10b981;\n}\n\n.create-card.friendly:hover {\n  border-color: #10b981;\n  box-shadow: 0 4px 20px rgba(16, 185, 129, 0.2);\n}\n\n.create-card.real {\n  border-left: 3px solid #ef4444;\n}\n\n.create-card.real:hover {\n  border-color: #ef4444;\n  box-shadow: 0 4px 20px rgba(239, 68, 68, 0.2);\n}\n\n.create-icon {\n  font-size: 40px;\n  width: 60px;\n  text-align: center;\n}\n\n/* Spinner Small */\n.spinner-small {\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top-color: white;\n  border-radius: 50%;\n  animation: spin 0.6s linear infinite;\n  display: inline-block;\n}\n\n/* Quick Actions Row */\n.quick-actions-row {\n  display: flex;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.join-by-code {\n  display: flex;\n  gap: 12px;\n  flex: 1;\n}\n\n.code-input {\n  flex: 1;\n  background: rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 40px;\n  padding: 12px 20px;\n  color: white;\n  font-size: 14px;\n}\n\n.code-input:focus {\n  outline: none;\n  border-color: #f59e0b;\n}\n\n.join-btn {\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 40px;\n  padding: 12px 24px;\n  color: white;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.join-btn:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.join-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.match-found {\n  margin-top: 16px;\n  padding: 10px 16px;\n  background: rgba(16, 185, 129, 0.2);\n  border-radius: 12px;\n  color: #10b981;\n  font-size: 13px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* Search Bar with Icon */\n.search-bar {\n  position: relative;\n  margin-bottom: 20px;\n}\n\n.search-bar .search-icon {\n  position: absolute;\n  left: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 16px;\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.search-bar .search-input {\n  width: 100%;\n  background: rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 40px;\n  padding: 12px 16px 12px 40px;\n  color: white;\n  font-size: 14px;\n}\n\n.search-bar .search-input:focus {\n  outline: none;\n  border-color: #f59e0b;\n}\n\n.clear-search {\n  position: absolute;\n  right: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  color: rgba(255, 255, 255, 0.5);\n  font-size: 18px;\n  cursor: pointer;\n}\n\n.clear-search:hover {\n  color: white;\n}\n\n/* Clear Filters Button */\n.clear-filters-btn {\n  margin-top: 20px;\n  background: rgba(245, 158, 11, 0.2);\n  border: 1px solid rgba(245, 158, 11, 0.3);\n  border-radius: 40px;\n  padding: 10px 24px;\n  color: #f59e0b;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.clear-filters-btn:hover {\n  background: rgba(245, 158, 11, 0.3);\n}\n\n/* Responsive Adjustments */\n@media (max-width: 768px) {\n  .time-option {\n    min-width: 70px;\n    padding: 8px;\n  }\n  \n  .time-desc {\n    display: none;\n  }\n  \n  .quick-actions-row {\n    flex-direction: column;\n  }\n  \n  .join-by-code {\n    flex-direction: column;\n  }\n  \n  .create-icon {\n    font-size: 32px;\n    width: 50px;\n  }\n}\n/* Flappy Lobby Specific Styles */\n\n.flappy-icon {\n  font-size: 36px;\n  background: linear-gradient(135deg, #10b981, #3b82f6);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  animation: flap 0.5s ease-in-out infinite;\n}\n\n@keyframes flap {\n  0%, 100% { transform: translateY(0); }\n  50% { transform: translateY(-3px); }\n}\n\n/* Quick Action Buttons */\n.quick-action.flappy-quick {\n  background: linear-gradient(135deg, #10b981, #3b82f6);\n  flex: 1;\n}\n\n.quick-action.flappy-quick:hover:not(:disabled) {\n  box-shadow: 0 4px 15px rgba(16, 185, 129, 0.4);\n}\n\n.practice-btn {\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 40px;\n  padding: 14px 24px;\n  color: white;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.practice-btn:hover {\n  background: rgba(255, 255, 255, 0.2);\n  transform: translateY(-2px);\n}\n\n/* Create Cards with Flappy Theme */\n.create-card.practice {\n  border-left: 3px solid #10b981;\n}\n\n.create-card.practice:hover {\n  border-color: #10b981;\n  box-shadow: 0 4px 20px rgba(16, 185, 129, 0.2);\n}\n\n.create-card.friendly {\n  border-left: 3px solid #3b82f6;\n}\n\n.create-card.friendly:hover {\n  border-color: #3b82f6;\n  box-shadow: 0 4px 20px rgba(59, 130, 246, 0.2);\n}\n\n.create-card.real {\n  border-left: 3px solid #ef4444;\n}\n\n.create-card.real:hover {\n  border-color: #ef4444;\n  box-shadow: 0 4px 20px rgba(239, 68, 68, 0.2);\n}\n\n/* Duration Options */\n.time-option {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  padding: 12px;\n  background: rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  min-width: 70px;\n}\n\n.time-option.selected {\n  border-color: #10b981;\n  background: rgba(16, 185, 129, 0.2);\n}\n\n.time-icon {\n  font-size: 20px;\n}\n\n.time-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: white;\n}\n\n.time-desc {\n  font-size: 9px;\n  color: rgba(255, 255, 255, 0.5);\n}\n\n/* Quick Actions Row */\n.quick-actions-row {\n  display: flex;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n/* Search Bar */\n.search-bar {\n  position: relative;\n  margin-bottom: 20px;\n}\n\n.search-bar .search-icon {\n  position: absolute;\n  left: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 16px;\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.search-bar .search-input {\n  width: 100%;\n  background: rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 40px;\n  padding: 12px 16px 12px 40px;\n  color: white;\n  font-size: 14px;\n}\n\n.search-bar .search-input:focus {\n  outline: none;\n  border-color: #10b981;\n}\n\n.clear-search {\n  position: absolute;\n  right: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  color: rgba(255, 255, 255, 0.5);\n  font-size: 18px;\n  cursor: pointer;\n}\n\n.clear-search:hover {\n  color: white;\n}\n\n/* Clear Filters Button */\n.clear-filters-btn {\n  margin-top: 20px;\n  background: rgba(16, 185, 129, 0.2);\n  border: 1px solid rgba(16, 185, 129, 0.3);\n  border-radius: 40px;\n  padding: 10px 24px;\n  color: #10b981;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.clear-filters-btn:hover {\n  background: rgba(16, 185, 129, 0.3);\n}\n\n/* Spinner Small */\n.spinner-small {\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top-color: white;\n  border-radius: 50%;\n  animation: spin 0.6s linear infinite;\n  display: inline-block;\n}\n\n/* Match Card Status Badge */\n.status-badge {\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.status-badge.pending {\n  background: rgba(251, 191, 36, 0.2);\n  color: #fbbf24;\n}\n\n.status-badge.ongoing {\n  background: rgba(16, 185, 129, 0.2);\n  color: #10b981;\n}\n\n.status-badge.completed {\n  background: rgba(107, 114, 128, 0.2);\n  color: #9ca3af;\n}\n\n/* Mode Badge */\n.mode-badge {\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.mode-badge.friendly {\n  background: rgba(59, 130, 246, 0.2);\n  color: #60a5fa;\n}\n\n.mode-badge.real {\n  background: rgba(239, 68, 68, 0.2);\n  color: #f87171;\n}\n\n/* Wager Badge */\n.wager-badge {\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 600;\n  background: rgba(251, 191, 36, 0.2);\n  color: #fbbf24;\n}\n\n/* Match Card */\n.match-card {\n  background: rgba(0, 0, 0, 0.3);\n  border-radius: 20px;\n  padding: 20px;\n  transition: all 0.3s ease;\n  margin-bottom: 16px;\n}\n\n.match-card:hover {\n  transform: translateX(4px);\n  background: rgba(0, 0, 0, 0.4);\n}\n\n.match-card.available {\n  border-left: 3px solid #10b981;\n}\n\n.match-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.match-id {\n  font-family: monospace;\n  font-size: 12px;\n  color: #a78bfa;\n  background: rgba(139, 92, 246, 0.2);\n  padding: 4px 12px;\n  border-radius: 20px;\n}\n\n.match-badges {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.match-players {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n}\n\n.player {\n  flex: 1;\n  text-align: center;\n}\n\n.player-role {\n  display: block;\n  font-size: 10px;\n  color: rgba(255, 255, 255, 0.5);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  margin-bottom: 4px;\n}\n\n.player-name {\n  font-size: 16px;\n  font-weight: 600;\n  color: white;\n}\n\n.player-name.waiting {\n  color: rgba(255, 255, 255, 0.5);\n  font-style: italic;\n}\n\n.vs-divider {\n  font-size: 12px;\n  font-weight: 700;\n  color: rgba(255, 255, 255, 0.5);\n  padding: 0 8px;\n}\n\n.match-details {\n  display: flex;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-bottom: 16px;\n  padding: 12px;\n  background: rgba(0, 0, 0, 0.2);\n  border-radius: 12px;\n}\n\n.detail-item {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.match-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n}\n\n.action-btn {\n  padding: 8px 20px;\n  border-radius: 40px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border: none;\n}\n\n.action-btn.join {\n  background: linear-gradient(135deg, #10b981, #3b82f6);\n  color: white;\n}\n\n.action-btn.play {\n  background: linear-gradient(135deg, #8b5cf6, #ec489a);\n  color: white;\n}\n\n.action-btn.cancel {\n  background: rgba(239, 68, 68, 0.2);\n  color: #f87171;\n}\n\n.action-btn.cancel:hover {\n  background: rgba(239, 68, 68, 0.3);\n}\n\n.action-btn.join:hover, .action-btn.play:hover {\n  transform: translateY(-2px);\n}\n\n/* Responsive Adjustments */\n@media (max-width: 768px) {\n  .time-option {\n    min-width: 60px;\n    padding: 8px;\n  }\n  \n  .time-desc {\n    display: none;\n  }\n  \n  .quick-actions-row {\n    flex-direction: column;\n  }\n  \n  .practice-btn {\n    justify-content: center;\n  }\n  \n  .match-players {\n    flex-direction: column;\n    text-align: center;\n  }\n  \n  .vs-divider {\n    display: none;\n  }\n  \n  .match-actions {\n    justify-content: center;\n  }\n  \n  .match-details {\n    flex-direction: column;\n    gap: 8px;\n  }\n}\n\n/* Game Guide Page Styles */\n\n.guide-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 32px;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.guide-icon-main {\n  font-size: 48px;\n  background: linear-gradient(135deg, #8b5cf6, #ec489a);\n  width: 64px;\n  height: 64px;\n  border-radius: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Navigation Chips */\n.guide-nav {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-bottom: 32px;\n  padding: 16px;\n  background: rgba(255, 255, 255, 0.05);\n  backdrop-filter: blur(10px);\n  border-radius: 60px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.nav-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 18px;\n  background: rgba(255, 255, 255, 0.08);\n  border-radius: 40px;\n  color: rgba(255, 255, 255, 0.8);\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.nav-chip:hover {\n  background: rgba(255, 255, 255, 0.15);\n  transform: translateY(-2px);\n  color: white;\n}\n\n.nav-chip-highlight {\n  background: linear-gradient(135deg, #8b5cf6, #ec489a);\n  color: white;\n  border: none;\n}\n\n.nav-chip-highlight:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 15px rgba(139, 92, 246, 0.4);\n}\n\n.chip-icon {\n  font-size: 16px;\n}\n\n/* Guide Cards */\n.guide-card {\n  background: rgba(255, 255, 255, 0.05);\n  backdrop-filter: blur(10px);\n  border-radius: 28px;\n  padding: 28px;\n  margin-bottom: 24px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  transition: all 0.3s ease;\n}\n\n.guide-card:hover {\n  transform: translateY(-2px);\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.general-card {\n  background: linear-gradient(135deg, rgba(139, 92, 246, 0.15), rgba(236, 72, 153, 0.1));\n  border: 1px solid rgba(139, 92, 246, 0.3);\n}\n\n.card-header {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 24px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.card-icon {\n  width: 52px;\n  height: 52px;\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 28px;\n}\n\n.card-title {\n  font-size: 20px;\n  font-weight: 700;\n  color: white;\n  margin: 0;\n}\n\n.card-subtitle {\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.6);\n  margin: 4px 0 0;\n}\n\n/* Guide Content */\n.guide-content {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.guide-block {\n  background: rgba(0, 0, 0, 0.2);\n  border-radius: 20px;\n  padding: 18px;\n}\n\n.guide-block.compact {\n  padding: 12px 18px;\n}\n\n.block-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #a78bfa;\n  margin: 0 0 12px;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.block-text {\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.85);\n  line-height: 1.6;\n  margin: 0;\n}\n\n.guide-list {\n  margin: 0;\n  padding-left: 20px;\n}\n\n.guide-list li {\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.8);\n  line-height: 1.6;\n  margin-bottom: 8px;\n}\n\n.guide-list li:last-child {\n  margin-bottom: 0;\n}\n\n/* Tips Block */\n.tips-block {\n  background: linear-gradient(135deg, rgba(16, 185, 129, 0.1), rgba(16, 185, 129, 0.05));\n  border-left: 3px solid #10b981;\n}\n\n.tips-list li {\n  color: #10b981 !important;\n}\n\n/* Command Block (WHOT specific) */\n.command-block {\n  background: linear-gradient(135deg, rgba(245, 158, 11, 0.1), rgba(245, 158, 11, 0.05));\n  border-left: 3px solid #f59e0b;\n}\n\n/* Formula Block */\n.formula-block {\n  background: rgba(0, 0, 0, 0.3);\n}\n\n.formula-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.formula-code {\n  display: block;\n  background: rgba(0, 0, 0, 0.5);\n  padding: 10px 14px;\n  border-radius: 12px;\n  font-family: 'Courier New', monospace;\n  font-size: 13px;\n  color: #fbbf24;\n  border-left: 3px solid #fbbf24;\n}\n\n/* Guide Grid */\n.guide-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(420px, 1fr));\n  gap: 24px;\n  margin-top: 8px;\n}\n\n/* Guide Footer */\n.guide-footer {\n  margin-top: 32px;\n  padding: 20px;\n  background: rgba(255, 255, 255, 0.03);\n  border-radius: 20px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  text-align: center;\n}\n\n.footer-content {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.footer-icon {\n  font-size: 18px;\n}\n\n/* Responsive */\n@media (max-width: 900px) {\n  .guide-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .guide-nav {\n    border-radius: 20px;\n    justify-content: center;\n  }\n  \n  .nav-chip {\n    padding: 6px 14px;\n    font-size: 12px;\n  }\n}\n\n@media (max-width: 640px) {\n  .guide-card {\n    padding: 20px;\n  }\n  \n  .card-header {\n    flex-direction: column;\n    text-align: center;\n  }\n  \n  .card-title {\n    font-size: 18px;\n  }\n  \n  .guide-block {\n    padding: 14px;\n  }\n  \n  .formula-code {\n    font-size: 11px;\n    overflow-x: auto;\n  }\n  \n  .guide-nav {\n    overflow-x: auto;\n    justify-content: flex-start;\n    border-radius: 16px;\n  }\n  \n  .footer-content {\n    flex-direction: column;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
